import React, { useState, useEffect } from "react";
import { Row, Col, Breadcrumb, Divider } from "antd";
import { Link, useLocation } from "react-router-dom";
import { Link as LinkSection, Element, Events, scrollSpy } from "react-scroll";
import { Player, BigPlayButton } from "video-react";
import CountUp from "react-countup";

import ScrollUpBtn from "components/ScrollUpBtn";
import CardDetail from "components/CardDetail";
import CardImage from "components/CardImage";
import DetailContact from "components/DetailContact";
import QuestBlog from "components/QuestBlog";
import ListImage from "components/ListImage";
import CarouselMulti from "components/CarouselMulti";
import FadeInSection from "components/FadeInSection";
import CardText from "components/CardText";
import NumberImage from "components/NumberImage";
import TableGPAX from "components/TableGPAX";

import {
  breadcrumbName,
  WebsiteEngi,
  ListColorContact,
  ListColor1,
  ListColor2,
  ListColorQ,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";
import { institute, contract } from "core/schemas";

import pencilGreen from "assets/images/svg/pencil-green.svg";
import downloadIcon from "assets/images/svg/icon-file-download.svg";

import rectangle1 from "assets/images/svg/rectangle-39.svg";
import rectangle2 from "assets/images/svg/rectangle-44.svg";

import digitech1 from "assets/images/svg/digitech1-c.svg";
import digitech2 from "assets/images/svg/digitech2-r.svg";
import digitech3 from "assets/images/svg/digitech3-e-1.svg";
import digitech4 from "assets/images/svg/digitech4-p.svg";
import digitech5 from "assets/images/svg/digitech5-e-2.svg";
import digitech6 from "assets/images/svg/digitech6-s.svg";

import learnIcon1 from "assets/images/svg/H09-1.svg";
import learnIcon2 from "assets/images/svg/H09-2.svg";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import iconPDF from "assets/images/svg/icon-file-pdf.svg";
import iconPDFPink from "assets/images/svg/icon-file-pdf-pink.svg";

import iconParagraph from "assets/images/svg/09-icon-paragraph.svg";

import iconScanner from "assets/images/svg/icon-scanner.svg";

import engineer from "assets/images/svg/engi.svg";
import engineer1 from "assets/images/png/engi1.png";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

import fatherMedi from "assets/images/png/medical-father.png";
import megiIcon from "assets/images/png/megi.png";
import sciTable from "assets/images/png/sci-table.png";
import maindataSci from "assets/images/png/illus-maindata_sci-scholaship-end.png";

import tech1 from "assets/images/jpg/dentistry-tech1.jpg";
import tech2 from "assets/images/jpg/dentistry-tech2.jpg";
import tech3 from "assets/images/jpg/dentistry-tech3.jpg";
import tech4 from "assets/images/jpg/dentistry-tech4.jpg";
import tech5 from "assets/images/jpg/dentistry-tech5.jpg";
import tech6 from "assets/images/jpg/dentistry-tech6.jpg";
import tech7 from "assets/images/jpg/dentistry-tech7.jpg";
import tech8 from "assets/images/jpg/dentistry-tech8.jpg";

import stuView from "assets/images/png/student_comp-01.png";

import videoIcon from "assets/images/svg/icon-video.svg";
import paperIcon from "assets/images/svg/icon-paper.svg";

import handRightIcon from "assets/images/svg/icon-awesome-hand-point-right.svg";
import picMedicine1 from "assets/images/png/medicine-1.png";
import picMedicine2 from "assets/images/jpg/medicine-2.jpg";
import picMedicine3 from "assets/images/jpg/medicine-3.jpg";

import engGPAX from "assets/images/png/04-11-illus.png";

import {
  Container,
  Title,
  TitleEN,
  ItemText,
  BoxTitle,
  BlockName,
  TextName,
  DetailName,
  DetailTop,
  DetailBottom,
  IconMore,
  NameCourse,
  SubTitle,
  BoxSub,
  SubDetail,
  TextNote,
  SubHead,
  CusttomBreadcrumb,
  Href,
  FixBox,
  CustomCarousel,
  Line,
  TextHead,
  DetailLink,
  TextBold,
  BoxImage,
  FixBoxLayout,
  CardContact,
  BoxPrint,
  SubBold,
  Detail,
  TttleSelect,
  TextPosition,
  TextScan,
  View,
  NumberList,
  Box,
  HoverAni,
} from "./courseInfoGroup.style";

const CourseInfoView = () => {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [gradeData, setGradeData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    slang === "department-engineering" && getCalGrade();
  }, [slang]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const getCalGrade = async () => {
    const response = await httpClient.get(`page/table_gpa?group=499`);

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setGradeData(data);
    } else {
      setGradeData([]);
    }
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getDataEnrollment = async () => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
    } else {
      setDepartmentData([]);
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(`${contract}?course=${id && id}`);

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const styleDetailContact = { marginBottom: "5px" };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const renderDetailLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <DetailLink bottom="0" color={ListColor1[slang]}>
          {name}
        </DetailLink>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  const listCrePes = {
    CERTIFICATION: digitech1,
    "RE & UP-SKILL": digitech2,
    "EXPERIENCE BASE": digitech3,
    PERSONALIZATION: digitech4,
    "EMERGING EDUTECH": digitech5,
    STANDARDIZATION: digitech6,
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkEng = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web eng">
        {newLink[0]}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{text}</u>
        </a>
      </div>
    );
  };

  const spliteLinkPhone = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {newLink[0]}
        <a href={`http://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkTeacher = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkRegis = (link, text, style) => {
    const newLink = link.split(text);
    return (
      <div className={style !== "" ? `link-web ${style}` : "link-web"}>
        {text}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkAnnounce = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteYoutube = (link, text, icon) => {
    const newLink = link.split(text);
    return (
      <div
        className={`link-web dentistry ${
          icon && icon === "none" && "left-none"
        }`}
      >
        {icon && icon === "file" ? (
          <img
            src={paperIcon}
            alt="icon title"
            style={{ width: "32px" }}
            loading="lazy"
          />
        ) : (
          icon &&
          icon !== "none" && (
            <img
              src={videoIcon}
              alt="icon title"
              style={{ width: "32px" }}
              loading="lazy"
            />
          )
        )}
        {icon && icon === "file" && <br />}
        <a href={`${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{text}</u>
        </a>
      </div>
    );
  };

  const spliteLinkProject = (data, text, link) => {
    const newLink = data.split(text);
    return (
      <div className="link-web bold">
        <span>Download</span>
        <a href={link} target="_blank" rel="noreferrer" download>
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteImage = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web text-link-image">
        {newLink[0]}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{text}</u>
        </a>
      </div>
    );
  };

  const renderBtn = (link, text) => {
    return (
      <div className="btn-readding">
        <a href={link} target="_blank" rel="noreferrer">
          <p>{text}</p>
        </a>
      </div>
    );
  };

  const styleImage = {
    maxWidth: "100%",
    margin: "20px 0",
  };

  const rednderImageSplit = (img) => {
    let newImg = img.split(" ");

    return (
      newImg.length > 0 && (
        <CustomCarousel autoplay bg={ListColor1[slang]}>
          {newImg[0] && (
            <img
              loading="lazy"
              src={newImg[0]}
              alt="icon occupation"
              style={{
                borderRadius: "20px",
                width: "100%",
              }}
            />
          )}

          {newImg[1] && (
            <img
              loading="lazy"
              src={newImg[1]}
              alt="icon occupation"
              style={{
                borderRadius: "20px",
                width: "100%",
              }}
            />
          )}
          {newImg[2] && (
            <img
              loading="lazy"
              src={newImg[2]}
              alt="icon occupation"
              style={{
                borderRadius: "20px",
                width: "100%",
              }}
            />
          )}
          {newImg[3] && (
            <img
              loading="lazy"
              src={newImg[3]}
              alt="icon occupation"
              style={{
                borderRadius: "20px",
                width: "100%",
              }}
            />
          )}
          {newImg[4] && (
            <img
              loading="lazy"
              src={newImg[4]}
              alt="icon occupation"
              style={{
                borderRadius: "20px",
                width: "100%",
              }}
            />
          )}
        </CustomCarousel>
      )
    );
  };

  const getHighlightedText = (text, highlight, color) => {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part, i) => (
          <span
            key={i}
            style={
              part.toLowerCase() === highlight.toLowerCase()
                ? { color: color }
                : { color: "#353535" }
            }
          >
            {part}
          </span>
        ))}
      </span>
    );
  };

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <CusttomBreadcrumb>
              {splitPath.map((item, i) => {
                if (i !== splitPath.length - 1 && i !== 0) {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}> {breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
            </CusttomBreadcrumb>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Title className="animate__animated animate__slideInDown animate__slow">
              {departmentData?.nameTH}
            </Title>
            <TitleEN className="animate__animated animate__flipInX animate__slow">
              {departmentData?.nameEN}
            </TitleEN>
          </Col>
        </Row>

        {windowWidth <= 1280
          ? departmentData?.message && (
              <Row className="row-title">
                <Col span={12}>
                  <BlockName row={slang === "department-agricultural" ? 3 : 2}>
                    <img
                      loading="lazy"
                      src={listImage1[slang]}
                      alt="icon title"
                      style={{ maxWidth: "104px", width: "100%" }}
                    />

                    <TextName>
                      {splitName(departmentData?.message?.title, 0)}
                      <span>
                        {splitName(departmentData?.message?.title, 1, true)}
                      </span>
                    </TextName>
                  </BlockName>

                  <div className="col-image-profile">
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.message?.image &&
                          departmentData?.message?.image[0]?.image_0
                        }
                        alt="dean"
                        style={{ marginTop: "20px", width: "100%" }}
                      />
                    </FadeInSection>
                  </div>

                  {departmentData?.message?.text &&
                    departmentData?.message?.text.map((item) => {
                      return slang === "department-degitech" ? (
                        <>
                          {item?.text_0 && (
                            <DetailTop bottom="0">{item?.text_0}</DetailTop>
                          )}

                          {item?.text_1 && (
                            <DetailBottom bottom="0" top="0">
                              {item?.text_1}
                            </DetailBottom>
                          )}
                          {item?.text_2 && (
                            <DetailBottom bottom="0" top="0">
                              {item?.text_2}
                            </DetailBottom>
                          )}
                          {item?.text_3 && (
                            <DetailBottom top="0">{item?.text_3}</DetailBottom>
                          )}
                        </>
                      ) : (
                        <>
                          {item?.text_0 && (
                            <DetailTop>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_0,
                                    `“ยินดีต้อนรับน้องใหม่ทุกคน”`,
                                    "#F28DBA"
                                  )
                                : item?.text_0}
                            </DetailTop>
                          )}
                          {item?.text_1 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_1,
                                    `“ขอความร่วมมือจากพวกเราทุกคนที่จะพัฒนาตัวเองร่วมกัน”`,
                                    "#8ADD96"
                                  )
                                : item?.text_1}
                            </DetailBottom>
                          )}
                          {item?.text_2 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_2,
                                    `“อาจารย์ที่ปรึกษา”`,
                                    "#4675B5"
                                  )
                                : item?.text_2}
                            </DetailBottom>
                          )}
                          {item?.text_3 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_3,
                                    `“มีความสุขในการเรียน รู้หน้าที่ รับผิดชอบตนเอง ดูแลกายใจของตนให้ดีใช้ปัญญาในการดำเนินชีวิตอย่างระมัดระวัง”`,
                                    "#F28DBA"
                                  )
                                : item?.text_3}
                            </DetailBottom>
                          )}
                        </>
                      );
                    })}
                </Col>

                {slang !== "department-social" &&
                  departmentData?.message?.image &&
                  departmentData?.message?.image.map((item) => {
                    return (
                      <>
                        <Col
                          span={11}
                          offset={1}
                          style={{ display: "flex", alignItems: "baseline" }}
                          className="col-image-profile"
                        ></Col>
                        {item?.image_1 && item?.image_2 && (
                          <Player
                            poster={item?.image_1}
                            className="img-people"
                            autoPlay
                            muted
                            playsInline
                            src={item?.image_2}
                          >
                            <BigPlayButton position="center" />
                          </Player>
                        )}
                      </>
                    );
                  })}
              </Row>
            )
          : departmentData?.message && (
              <Row className="row-title">
                <Col span={12}>
                  <BlockName row={slang === "department-agricultural" ? 3 : 2}>
                    <img
                      loading="lazy"
                      src={listImage1[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />

                    <TextName>
                      {splitName(departmentData?.message?.title, 0)}
                      <span>
                        {splitName(departmentData?.message?.title, 1, true)}
                      </span>
                    </TextName>
                  </BlockName>

                  {departmentData?.message?.text &&
                    departmentData?.message?.text.map((item) => {
                      return slang === "department-degitech" ? (
                        <>
                          {item?.text_0 && (
                            <DetailTop bottom="0">{item?.text_0}</DetailTop>
                          )}

                          {item?.text_1 && (
                            <DetailBottom bottom="0" top="0">
                              {item?.text_1}
                            </DetailBottom>
                          )}
                          {item?.text_2 && (
                            <DetailBottom bottom="0" top="0">
                              {item?.text_2}
                            </DetailBottom>
                          )}
                          {item?.text_3 && (
                            <DetailBottom top="0">{item?.text_3}</DetailBottom>
                          )}
                        </>
                      ) : (
                        <>
                          {item?.text_0 && (
                            <DetailTop>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_0,
                                    `“ยินดีต้อนรับน้องใหม่ทุกคน”`,
                                    "#F28DBA"
                                  )
                                : item?.text_0}
                            </DetailTop>
                          )}
                          {item?.text_1 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_1,
                                    `“ขอความร่วมมือจากพวกเราทุกคนที่จะพัฒนาตัวเองร่วมกัน”`,
                                    "#8ADD96"
                                  )
                                : item?.text_1}
                            </DetailBottom>
                          )}
                          {item?.text_2 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_2,
                                    `“อาจารย์ที่ปรึกษา”`,
                                    "#4675B5"
                                  )
                                : item?.text_2}
                            </DetailBottom>
                          )}
                          {item?.text_3 && (
                            <DetailBottom>
                              {slang === "department-public-health"
                                ? getHighlightedText(
                                    item?.text_3,
                                    `“มีความสุขในการเรียน รู้หน้าที่ รับผิดชอบตนเอง ดูแลกายใจของตนให้ดีใช้ปัญญาในการดำเนินชีวิตอย่างระมัดระวัง”`,
                                    "#F28DBA"
                                  )
                                : item?.text_3}
                            </DetailBottom>
                          )}
                        </>
                      );
                    })}
                </Col>

                {departmentData?.message?.image &&
                  departmentData?.message?.image.map((item) => {
                    return (
                      <>
                        <Col
                          span={11}
                          offset={1}
                          style={{ display: "flex", alignItems: "baseline" }}
                          className="col-image-profile"
                        >
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="dean"
                              width={"100%"}
                            />
                          </FadeInSection>
                        </Col>
                        {slang !== "department-social" &&
                          item?.image_1 &&
                          item?.image_2 && (
                            <Player
                              poster={item?.image_1}
                              className="img-people"
                              autoPlay
                              muted
                              playsInline
                              src={item?.image_2}
                            >
                              <BigPlayButton position="center" />
                            </Player>
                          )}
                      </>
                    );
                  })}
              </Row>
            )}

        {departmentData?.contract && (
          <Row>
            <Col span={24}>
              <BlockName row={slang === "department-agricultural" ? 3 : 2}>
                <img
                  loading="lazy"
                  src={listImage2[slang]}
                  alt="icon title"
                  style={{ width: "104px" }}
                />
                <TextName>
                  {slang === "department-science"
                    ? "หลักสูตรระดับปริญญาตรีในสำนักวิชาวิทยาศาสตร์"
                    : departmentData?.contract[0]?.department}
                </TextName>
              </BlockName>

              <Row className="row-name-course top" gutter={[24, 6]}>
                {departmentData?.contract.slice(1).map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <Href
                        to={
                          slang === "department-engineering"
                            ? WebsiteEngi[item?.department]
                            : item?.slang
                        }
                        rel="noopener noreferrer"
                        target={
                          slang === "department-engineering"
                            ? "_blank"
                            : "_self"
                        }
                      >
                        <NameCourse>{item?.department}</NameCourse>
                      </Href>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        )}

        {departmentData?.advice && (
          <Row>
            <Col span={24}>
              <BlockName row={slang === "department-agricultural" ? 3 : 2}>
                <img
                  loading="lazy"
                  src={listImage3[slang]}
                  alt="icon title"
                  style={{ width: "104px" }}
                />
                <TextName>{departmentData?.advice?.title}</TextName>
              </BlockName>

              <Row className="row-question" gutter={[24, 6]}>
                {departmentData?.advice?.text &&
                  departmentData?.advice?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 === "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                        item?.text_0 ===
                          "เรียนพยาบาล มทส. อย่างไรให้จบตามเวลา ?" ? (
                          <Col span={8}>
                            {renderLink(
                              "เรียนอย่างไรให้จบตามเวลา ?",
                              item?.text_0
                            )}
                          </Col>
                        ) : (
                          <Col span={8}>
                            {renderLink(item?.text_0, item?.text_0)}
                          </Col>
                        )}

                        {item?.text_1 === "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                        item?.text_1 === "เรียนแพทย์อย่างไรให้จบตามเวลา ?" ? (
                          <Col span={8}>
                            {renderLink(
                              "เรียนอย่างไรให้จบตามเวลา ?",
                              item?.text_1
                            )}
                          </Col>
                        ) : (
                          <Col span={8}>
                            {renderLink(item?.text_1, item?.text_1)}
                          </Col>
                        )}

                        {item?.text_2 && (
                          <Col span={8}>
                            {renderLink(item?.text_2, item?.text_2)}
                          </Col>
                        )}

                        {item?.text_3 && (
                          <Col span={8}>
                            {renderLink(item?.text_3, item?.text_3)}
                          </Col>
                        )}
                        {item?.text_4 && (
                          <Col span={8}>
                            {renderLink(item?.text_4, item?.text_4)}
                          </Col>
                        )}
                        {item?.text_5 && (
                          <Col span={8}>
                            {renderLink(item?.text_5, item?.text_5)}
                          </Col>
                        )}
                        {item?.text_6 && (
                          <Col span={8}>
                            {renderLink(item?.text_6, item?.text_6)}
                          </Col>
                        )}
                        {item?.text_7 && (
                          <Col span={8}>
                            {renderLink(item?.text_7, item?.text_7)}
                          </Col>
                        )}
                        {item?.text_8 && (
                          <Col span={8}>
                            {renderLink(item?.text_8, item?.text_8)}
                          </Col>
                        )}
                        {item?.text_9 && (
                          <Col span={8}>
                            {renderLink(item?.text_9, item?.text_9)}
                          </Col>
                        )}
                        {item?.text_10 && (
                          <Col span={8}>
                            {renderLink(item?.text_10, item?.text_10)}
                          </Col>
                        )}
                        {item?.text_11 && (
                          <Col span={8}>
                            {renderLink(item?.text_11, item?.text_11)}
                          </Col>
                        )}
                        {item?.text_12 && (
                          <Col span={8}>
                            {renderLink(item?.text_12, item?.text_12)}
                          </Col>
                        )}
                        {item?.text_13 && (
                          <Col span={8}>
                            {renderLink(item?.text_13, item?.text_13)}
                          </Col>
                        )}
                        {item?.text_14 && (
                          <Col span={8}>
                            {renderLink(item?.text_14, item?.text_14)}
                          </Col>
                        )}
                        {item?.text_15 && (
                          <Col span={8}>
                            {renderLink(item?.text_15, item?.text_15)}
                          </Col>
                        )}
                        {item?.text_16 && (
                          <Col span={8}>
                            {renderLink(item?.text_16, item?.text_16)}
                          </Col>
                        )}
                        {item?.text_17 && (
                          <Col span={8}>
                            {renderLink(item?.text_17, item?.text_17)}
                          </Col>
                        )}
                        {item?.text_18 && (
                          <Col span={8}>
                            {renderLink(item?.text_18, item?.text_18)}
                          </Col>
                        )}
                        {item?.text_19 && (
                          <Col span={8}>
                            {renderLink(item?.text_19, item?.text_19)}
                          </Col>
                        )}
                        {item?.text_20 && (
                          <Col span={8}>
                            {renderLink(item?.text_20, item?.text_20)}
                          </Col>
                        )}
                      </>
                    );
                  })}
              </Row>
            </Col>
          </Row>
        )}

        {departmentData?.misstion && (
          <Element name={departmentData?.misstion?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="50">{departmentData?.misstion?.title}</SubTitle>
              <Row gutter={24} className="row-detail-card">
                {departmentData?.misstion?.data.map((item, index) => {
                  return (
                    index < 3 && (
                      <>
                        <Col span={8} key={index}>
                          <FadeInSection axis="x">
                            <img
                              loading="lazy"
                              src={item?.image ? item?.image : engineer}
                              alt="misstion"
                              style={{
                                width: "100%",
                                borderRadius: "20px",
                                marginBottom: "20px",
                              }}
                            />
                          </FadeInSection>
                          <SubHead font="Noto Sans Thai Bold">
                            {item?.title}
                          </SubHead>

                          {item?.text_0 && (
                            <SubDetail
                              top="0"
                              bottom={
                                index === 0 && departmentData?.misstion?.data[3]
                                  ? "35"
                                  : "0"
                              }
                              color={
                                item?.title === "ค่านิยม “WELL”"
                                  ? "#81000F"
                                  : "var(--black)"
                              }
                            >
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {index === 0 && departmentData?.misstion?.data[3] && (
                            <>
                              <SubHead font="Noto Sans Thai Bold">
                                {departmentData?.misstion?.data[3]?.title}
                              </SubHead>
                              {departmentData?.misstion?.data[3]?.text_0 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color="var(--black)"
                                >
                                  {departmentData?.misstion?.data[3]?.text_0}
                                </SubDetail>
                              )}
                            </>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              color={
                                item?.title === "ค่านิยม “WELL”"
                                  ? "#81000F"
                                  : "var(--black)"
                              }
                            >
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              color={
                                item?.title === "ค่านิยม “WELL”"
                                  ? "#81000F"
                                  : "var(--black)"
                              }
                            >
                              {item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              color={
                                item?.title === "ค่านิยม “WELL”"
                                  ? "#81000F"
                                  : "var(--black)"
                              }
                            >
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_7}
                            </SubDetail>
                          )}
                        </Col>
                      </>
                    )
                  );
                })}
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-public-health" && departmentData?.about && (
          <Element name={departmentData?.about?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.about?.title}</SubTitle>
                {departmentData?.about?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail indent="32" bottom="20">
                          {item?.text_0}
                        </SubDetail>
                      )}

                      {item?.text_2 && (
                        <TextHead indent="32" style={{ marginLeft: "30px" }}>
                          {item?.text_2}
                        </TextHead>
                      )}
                    </>
                  );
                })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.about?.image &&
                  departmentData?.about?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel
                          autoplay
                          bg={ListColor1[slang]}
                          speed="500"
                        >
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
            </Row>
            {departmentData?.about &&
              departmentData?.about.text &&
              departmentData?.about?.text.map((item) => {
                return (
                  <>
                    <Row
                      gutter={24}
                      className="row-group"
                      style={{ marginTop: "0px" }}
                    >
                      <Col span={11}>
                        {item?.text_13 && (
                          <TextBold bottom="20">{item?.text_3}</TextBold>
                        )}
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_9}
                          </SubDetail>
                        )}
                        {item?.text_10 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_10}
                          </SubDetail>
                        )}
                        {item?.text_11 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_11}
                          </SubDetail>
                        )}
                        {item?.text_12 && (
                          <SubDetail top="0">{item?.text_12}</SubDetail>
                        )}
                      </Col>
                      <Col span={12} offset={1}>
                        {item?.text_13 && (
                          <TextBold bottom="20" style={{ marginLeft: "30px" }}>
                            {item?.text_13}
                          </TextBold>
                        )}
                        {item?.text_14 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_14}
                          </SubDetail>
                        )}
                        {item?.text_15 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_15}
                          </SubDetail>
                        )}
                        {item?.text_16 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_16}
                          </SubDetail>
                        )}
                        {item?.text_17 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_17}
                          </SubDetail>
                        )}
                        {item?.text_18 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_18}
                          </SubDetail>
                        )}
                        {item?.text_19 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_19}
                          </SubDetail>
                        )}
                        {item?.text_20 && (
                          <SubDetail top="0">{item?.text_20}</SubDetail>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "0px" }}>
                      <Col span={24}>
                        {item?.text_21 && (
                          <TextBold bottom="20" style={{ marginLeft: "30px" }}>
                            {item?.text_21}
                          </TextBold>
                        )}
                        {item?.text_22 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_22}
                          </SubDetail>
                        )}
                        {item?.text_23 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_23}
                          </SubDetail>
                        )}
                        {item?.text_24 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_24}
                          </SubDetail>
                        )}
                        {item?.text_25 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_25}
                          </SubDetail>
                        )}
                        {item?.text_26 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_26}
                          </SubDetail>
                        )}
                        {item?.text_27 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_27}
                          </SubDetail>
                        )}
                        {item?.text_28 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_28}
                          </SubDetail>
                        )}

                        {item?.text_29 && (
                          <SubDetail top="0">{item?.text_29}</SubDetail>
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
          </Element>
        )}

        {departmentData?.evaluation_student && (
          <Element name={departmentData?.evaluation_student?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.evaluation_student?.image ? (
                    departmentData?.evaluation_student?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "10px",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "10px",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "10px",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>
                    {departmentData?.evaluation_student?.title}
                  </SubTitle>
                  {departmentData?.evaluation_student?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_4}
                          </SubDetail>
                        )}

                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_6}
                          </SubDetail>
                        )}

                        {item?.text_7 && (
                          <SubHead bottom="10">{item?.text_7}</SubHead>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {spliteLink(item?.text_8, "1) Log in : ")}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_9}
                          </SubDetail>
                        )}
                        {item?.text_10 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_10}
                          </SubDetail>
                        )}
                        {item?.text_11 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_11}
                          </SubDetail>
                        )}

                        {item?.text_12 && <TextNote>{item?.text_12}</TextNote>}
                      </>
                    );
                  })}
                </Col>
              </Row>
              {departmentData?.evaluation_course && (
                <>
                  <SubHead bottom="20" top="20">
                    {departmentData?.evaluation_course?.title}
                  </SubHead>

                  {departmentData?.evaluation_course?.text &&
                    departmentData?.evaluation_course?.text[0]?.text_0 && (
                      <SubDetail indent="32" top="0">
                        {departmentData?.evaluation_course?.text[0]?.text_0}
                      </SubDetail>
                    )}
                </>
              )}
            </FixBox>
          </Element>
        )}

        {departmentData?.end && (
          <Element name={departmentData?.end?.title}>
            <SubTitle top="50">{departmentData?.end?.title}</SubTitle>
            {departmentData?.end?.text &&
              departmentData?.end?.text[0]?.text_0 && (
                <SubDetail indent="35">
                  {departmentData?.end?.text[0]?.text_0}
                </SubDetail>
              )}

            {departmentData?.end_1 && departmentData?.end_2 && (
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <FadeInSection axis="y">
                    <img
                      loading="lazy"
                      src={
                        departmentData?.end_1?.image &&
                        departmentData?.end_1?.image[0]?.image_0
                      }
                      alt="pros icon"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        margin: "0 0 20px 0",
                      }}
                    />
                  </FadeInSection>
                  <SubHead bottom="20">{departmentData?.end_1?.title}</SubHead>
                  {departmentData?.end_1?.text[0]?.text_0 && (
                    <>
                      <SubDetail top="0" indent="32">
                        {departmentData?.end_1?.text[0]?.text_0}
                      </SubDetail>
                      <SubHead bottom="0">อาชีพที่เกี่ยวข้อง</SubHead>
                      <TextPosition top="0" bottom="0">
                        {departmentData?.end_1?.text[0]?.text_1}
                      </TextPosition>
                      {departmentData?.end_1?.text[0]?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {departmentData?.end_1?.text[0]?.text_2}
                        </SubDetail>
                      )}
                      <TextPosition top="0" bottom="0">
                        {departmentData?.end_1?.text[0]?.text_3}
                      </TextPosition>
                      {departmentData?.end_1?.text[0]?.text_4 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {departmentData?.end_1?.text[0]?.text_4}
                        </SubDetail>
                      )}
                      {departmentData?.end_1?.text[0]?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {departmentData?.end_1?.text[0]?.text_5}
                        </SubDetail>
                      )}
                      {departmentData?.end_1?.text[0]?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {departmentData?.end_1?.text[0]?.text_6}
                        </SubDetail>
                      )}
                    </>
                  )}
                </Col>
                <Col span={12}>
                  <FadeInSection axis="y">
                    <img
                      loading="lazy"
                      src={
                        departmentData?.end_2?.image &&
                        departmentData?.end_2?.image[0]?.image_0
                      }
                      alt="pros icon"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        margin: "0 0 20px 0",
                      }}
                    />
                  </FadeInSection>
                  <SubHead bottom="20">{departmentData?.end_2?.title}</SubHead>

                  {departmentData?.end_2?.text &&
                    departmentData?.end_2?.text[0]?.text_0 && (
                      <>
                        <SubDetail top="0" indent="32">
                          {departmentData?.end_2?.text[0]?.text_0}
                        </SubDetail>
                        <SubHead bottom="0">
                          {departmentData?.end_2?.text[0]?.text_1}
                        </SubHead>
                        <TextPosition top="0" bottom="0">
                          {departmentData?.end_2?.text[0]?.text_2}
                        </TextPosition>
                        {departmentData?.end_2?.text[0]?.text_3 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_2?.text[0]?.text_3}
                          </SubDetail>
                        )}
                        <TextPosition top="0" bottom="0">
                          {departmentData?.end_2?.text[0]?.text_4}
                        </TextPosition>
                        {departmentData?.end_2?.text[0]?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_2?.text[0]?.text_5}
                          </SubDetail>
                        )}
                        {departmentData?.end_2?.text[0]?.text_6 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_2?.text[0]?.text_6}
                          </SubDetail>
                        )}
                        {departmentData?.end_2?.text[0]?.text_7 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_2?.text[0]?.text_7}
                          </SubDetail>
                        )}
                      </>
                    )}
                </Col>
              </Row>
            )}

            {departmentData?.end_3 && (
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <FadeInSection axis="y">
                    <img
                      loading="lazy"
                      src={
                        departmentData?.end_3?.image &&
                        departmentData?.end_3?.image[0]?.image_0
                      }
                      alt="pros icon"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        margin: "0 0 20px 0",
                      }}
                    />
                  </FadeInSection>
                  <SubHead bottom="20">{departmentData?.end_3?.title}</SubHead>

                  {departmentData?.end_3?.text &&
                    departmentData?.end_3?.text[0]?.text_0 && (
                      <>
                        <SubDetail top="0" indent="32">
                          {departmentData?.end_3?.text[0]?.text_0}
                        </SubDetail>
                        <SubHead bottom="0">
                          {departmentData?.end_3?.text[0]?.text_1}
                        </SubHead>
                        <TextPosition top="0" bottom="0">
                          {departmentData?.end_3?.text[0]?.text_2}
                        </TextPosition>
                        {departmentData?.end_3?.text[0]?.text_3 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_3}
                          </SubDetail>
                        )}
                        {departmentData?.end_3?.text[0]?.text_4 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_4}
                          </SubDetail>
                        )}
                        {departmentData?.end_3?.text[0]?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_5}
                          </SubDetail>
                        )}
                        {departmentData?.end_3?.text[0]?.text_6 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_6}
                          </SubDetail>
                        )}

                        <TextPosition top="0" bottom="0">
                          {departmentData?.end_3?.text[0]?.text_7}
                        </TextPosition>
                        {departmentData?.end_3?.text[0]?.text_8 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_8}
                          </SubDetail>
                        )}
                        {departmentData?.end_3?.text[0]?.text_9 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_9}
                          </SubDetail>
                        )}
                        {departmentData?.end_3?.text[0]?.text_10 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {departmentData?.end_3?.text[0]?.text_10}
                          </SubDetail>
                        )}
                      </>
                    )}
                </Col>
              </Row>
            )}
          </Element>
        )}

        {departmentData?.intro && (
          <Element name={departmentData?.intro?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.intro?.title}</SubTitle>
                  {departmentData?.intro?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail bottom="0">{item?.text_1}</SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.intro?.image ? (
                    departmentData?.intro?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={fatherMedi}
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.introduct && (
          <Element name={departmentData?.introduct?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.introduct?.image ? (
                  departmentData?.introduct?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.introduct?.title}</SubTitle>
                {departmentData?.introduct?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <TextBold bottom="0">{item?.text_0}</TextBold>
                      )}
                      {item?.text_1 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_1}
                        </SubDetail>
                      )}

                      {item?.text_2 && (
                        <TextBold bottom="0">{item?.text_2}</TextBold>
                      )}
                      {item?.text_3 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail bottom="0" top="0">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail top="0">{item?.text_8}</SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-medicine" &&
          departmentData?.teaching_management &&
          departmentData?.teaching_management_1 && (
            <Element name={departmentData?.teaching_management?.title}>
              <FixBox bg={ListColor2[slang]}>
                <SubTitle align="center" top="50">
                  {departmentData?.teaching_management?.title}
                </SubTitle>

                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    {departmentData?.teaching_management?.image ? (
                      departmentData?.teaching_management?.image.map((item) => {
                        return (
                          <FadeInSection axis="y">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                    <SubHead font="Noto Sans Thai Bold" bottom="10">
                      {departmentData?.teaching_management?.title}
                    </SubHead>
                    {departmentData?.teaching_management?.text[0]?.text_0 && (
                      <>
                        {departmentData?.teaching_management?.text[0]
                          ?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {
                              departmentData?.teaching_management?.text[0]
                                ?.text_1
                            }
                          </SubDetail>
                        )}

                        {departmentData?.teaching_management?.text[0]
                          ?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {
                              departmentData?.teaching_management?.text[0]
                                ?.text_2
                            }
                          </SubDetail>
                        )}
                        {departmentData?.teaching_management?.text[0]
                          ?.text_3 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {
                              departmentData?.teaching_management?.text[0]
                                ?.text_3
                            }
                          </SubDetail>
                        )}
                        {departmentData?.teaching_management?.text[0]
                          ?.text_4 && (
                          <SubDetail top="0" bottom="0" indent="35">
                            {
                              departmentData?.teaching_management?.text[0]
                                ?.text_4
                            }
                          </SubDetail>
                        )}
                      </>
                    )}
                  </Col>
                  <Col span={12}>
                    {departmentData?.teaching_management_1?.image ? (
                      departmentData?.teaching_management_1?.image.map(
                        (item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        }
                      )
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}

                    <SubHead font="Noto Sans Thai Bold" bottom="10">
                      {departmentData?.teaching_management_1?.title}
                    </SubHead>

                    {departmentData?.teaching_management_1?.text &&
                      departmentData?.teaching_management_1?.text[0]
                        ?.text_0 && (
                        <>
                          <SubDetail top="0" bottom="0" indent="35">
                            {
                              departmentData?.teaching_management_1?.text[0]
                                ?.text_0
                            }
                          </SubDetail>

                          {departmentData?.teaching_management_1?.text[0]
                            ?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {
                                departmentData?.teaching_management_1?.text[0]
                                  ?.text_1
                              }
                            </SubDetail>
                          )}

                          {departmentData?.teaching_management_1?.text[0]
                            ?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {
                                departmentData?.teaching_management_1?.text[0]
                                  ?.text_2
                              }
                            </SubDetail>
                          )}
                          {departmentData?.teaching_management_1?.text[0]
                            ?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {
                                departmentData?.teaching_management_1?.text[0]
                                  ?.text_3
                              }
                            </SubDetail>
                          )}
                          {departmentData?.teaching_management_1?.text[0]
                            ?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {
                                departmentData?.teaching_management_1?.text[0]
                                  ?.text_4
                              }
                            </SubDetail>
                          )}
                        </>
                      )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {slang === "department-medicine" && departmentData?.register && (
          <Element name={departmentData?.register?.title}>
            <SubTitle align="center" top="50">
              {departmentData?.register?.title}
            </SubTitle>

            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.register?.text[0]?.text_0 && (
                  <SubHead font="Noto Sans Thai Bold" bottom="10">
                    {departmentData?.register?.text[0]?.text_0}
                  </SubHead>
                )}
                {departmentData?.register?.text[0]?.text_1 && (
                  <SubDetail top="0" bottom="0">
                    {departmentData?.register?.text[0]?.text_1}
                  </SubDetail>
                )}
                {departmentData?.register?.text[0]?.text_2 && (
                  <SubDetail top="0" bottom="0">
                    {spliteLinkRegis(
                      departmentData?.register?.text[0]?.text_2,
                      "2) ตรวจสอบรายวิชา และกลุ่มเรียนที่สามารถลงได้ตามสาขาวิชาได้ที่ ",
                      "medicine"
                    )}
                  </SubDetail>
                )}
                {departmentData?.register?.text[0]?.text_3 && (
                  <SubDetail top="0">
                    {spliteLinkRegis(
                      departmentData?.register?.text[0]?.text_3,
                      "3) ระบบทะเบียน ",
                      "medicine"
                    )}
                  </SubDetail>
                )}
              </Col>
              <Col span={12}>
                {departmentData?.register?.text[0]?.text_4 && (
                  <SubHead font="Noto Sans Thai Bold" bottom="10">
                    {departmentData?.register?.text[0]?.text_4}
                  </SubHead>
                )}
                {departmentData?.register?.text[0]?.text_5 && (
                  <SubDetail top="0" bottom="0">
                    {departmentData?.register?.text[0]?.text_5}
                  </SubDetail>
                )}
                {departmentData?.register?.text[0]?.text_6 && (
                  <SubDetail top="0" bottom="0">
                    {departmentData?.register?.text[0]?.text_6}
                  </SubDetail>
                )}
                {departmentData?.register?.text[0]?.text_7 && (
                  <SubDetail top="0">
                    {departmentData?.register?.text[0]?.text_7}
                  </SubDetail>
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.nl && (
          <Element name={departmentData?.nl?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <SubTitle>{departmentData?.nl?.title}</SubTitle>
                  {departmentData?.nl?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && <SubDetail>{item?.text_0}</SubDetail>}

                        <SubDetail bottom="0" indent="35">
                          <span style={{ color: "#176543" }}>
                            {" "}
                            1. BASIC MEDICAL SCIENCES
                          </span>{" "}
                          เป็นการสอบขั้นตอนที่ 1
                          เพื่อประเมินความรู้ทางด้านวิทยาศาสตร์การแพทย์พื้นฐาน
                          สอบตอนจบปี 3 ความรู้ pre-clinic มีสอบปีละ 3 ครั้ง
                        </SubDetail>
                        <SubDetail bottom="0" top="0" indent="35">
                          <span style={{ color: "#176543" }}>
                            2. CLINICAL SCIENCES
                          </span>
                          เป็นการสอบขั้นที่ 2
                          เพื่อประเมินความรู้ทางด้านวิทยาศาสตร์การแพทย์คลินิก
                          สอบตอนจบปี 5
                        </SubDetail>
                        <SubDetail bottom="20" top="0" indent="35">
                          <span style={{ color: "#176543" }}>
                            3. OBJECTIVE STRUCTURED CLINICAL EXAMINATION : OSCE
                          </span>
                          เป็นการสอบขั้นที่ 3
                          เพื่อประเมินทักษะและหัตถการทางคลินิก สอบตอนจบปี 6
                        </SubDetail>

                        <TextNote>
                          Note: การที่จะสอบ ขั้นตอนที่ 3 ได้ต้องผ่านขั้นตอนที่ 1
                          และขั้นตอนที่ 2
                          เสียก่อนแต่ถ้านักศึกษาแพทย์สอบขั้นตอนที่ 1 ไม่ผ่าน
                          ก็ยังสามารถสอบขั้นตอนที่ 2 ได้ (ยังขึ้นไปเรียนชั้นปี 4
                          ได้)
                        </TextNote>
                      </>
                    );
                  })}
                </Col>
                <Col span={11} offset={1}>
                  {departmentData?.nl?.image ? (
                    departmentData?.nl?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  {departmentData?.nl?.text.map((item) => {
                    return (
                      <>
                        {item?.text_4 && (
                          <SubHead font="Noto Sans Thai Bold" bottom="10">
                            {item?.text_4}
                          </SubHead>
                        )}
                        {item?.text_5 && (
                          <SubDetail bottom="0" top="0" indent="35">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail bottom="0" top="0" indent="35">
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail bottom="0" top="0" indent="35">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail bottom="0" top="0" indent="35">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" indent="35">
                            {item?.text_}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.support && (
          <Element name={departmentData?.support?.title}>
            <SubTitle top="50" align="center">
              {departmentData?.support?.title}
            </SubTitle>
            {departmentData?.support?.text.map((item) => {
              return (
                <>
                  <Row gutter={24} className="row-detail-card">
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.support?.image
                              ? departmentData?.support?.image[0]?.image_0
                              : picMedicine1
                          }
                          alt="support icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        />
                      </FadeInSection>

                      {item?.text_0 && (
                        <SubHead font="Noto Sans Thai Bold">
                          {item?.text_0}
                        </SubHead>
                      )}
                      <SubDetail>
                        1) ทุนเรียนดี (ได้รับยกเว้นค่าหน่วยกิต)
                        <div className="link-web">
                          <a
                            href={`https://beta.sut.ac.th/dsa-scholar/wp-content/uploads/sites/183/2021/07/%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8-%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8C-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%97%E0%B8%B8%E0%B8%99.pdf`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u style={{ color: "#176543" }}>เกณฑ์การลงทุน</u>
                          </a>
                        </div>
                      </SubDetail>
                      <SubDetail>
                        2) ทุนขาดแคลนทุนทรัพย์
                        แหล่งทุนที่ได้รับมาจากภายนอกมหาวิทยาลัย สำนักวิชาฯ
                        เป็นผู้พิจารณาให้ทุน
                        <div className="link-web">
                          <a
                            href={`https://www.facebook.com/med.scholarship/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u style={{ color: "#176543" }}>
                              เฟซบุ๊กงานทุน สวพ. มทส.
                            </u>
                          </a>
                        </div>
                      </SubDetail>
                      <SubDetail>
                        3) กองทุนให้กู้ยืมเพื่อการศึกษา กยศ. กรอ.
                        ดำเนินการผ่านงานทุนการศึกษาของมหาวิทยาลัย
                        <div className="link-web">
                          <a
                            href={`https://www.facebook.com/sut.studentloan.fanpage/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u style={{ color: "#176543" }}>
                              เฟซบุ๊ก กยศ. มหาวิทยาลัยเทคโนโลยีสุรนารี{" "}
                            </u>
                          </a>
                        </div>
                      </SubDetail>
                    </Col>
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.support?.image
                              ? departmentData?.support?.image[0]?.image_1
                              : picMedicine2
                          }
                          alt="support icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        />
                      </FadeInSection>
                      {item?.text_4 && (
                        <SubHead font="Noto Sans Thai Bold">
                          {item?.text_4}
                        </SubHead>
                      )}
                      {item?.text_5 && (
                        <SubDetail bottom="0">{item?.text_5}</SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      <SubDetail top="0">
                        • คลินิกวัยรุ่น รพ.มทส เปิดให้บริการทุกวันพฤหัสบดี เวลา
                        13.00-16.00 น.
                        <div className="link-web">
                          <a
                            href={`https://www.facebook.com/people/%E0%B8%84%E0%B8%A5%E0%B8%B4%E0%B8%99%E0%B8%B4%E0%B8%81%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B8%A3%E0%B8%B8%E0%B9%88%E0%B8%99-%E0%B8%A3%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B9%80%E0%B8%97%E0%B8%84%E0%B9%82%E0%B8%99%E0%B9%82%E0%B8%A5%E0%B8%A2%E0%B8%B5%E0%B8%AA%E0%B8%B8%E0%B8%A3%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%B5/100057333614334/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u style={{ color: "#176543" }}>
                              เฟซบุ๊ก คลินิกวัยรุ่น
                              รพ.มหาวิทยาลัยเทคโนโลยีสุรนารี
                            </u>
                          </a>
                        </div>
                      </SubDetail>
                    </Col>
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.support?.image
                              ? departmentData?.support?.image[0]?.image_2
                              : picMedicine3
                          }
                          alt="support icon"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        />
                      </FadeInSection>
                      {item?.text_9 && (
                        <SubHead font="Noto Sans Thai Bold">
                          {item?.text_9}
                        </SubHead>
                      )}
                      {item?.text_10 && (
                        <SubDetail bottom="0">{item?.text_10}</SubDetail>
                      )}
                      {item?.text_11 && (
                        <SubDetail top="0">{item?.text_11}</SubDetail>
                      )}
                    </Col>
                  </Row>
                </>
              );
            })}
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.rule && (
          <Element name={departmentData?.rule?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle align="center">{departmentData?.rule?.title}</SubTitle>
              <Detail color="#176543" align="center">
                <a
                  href="https://web.sut.ac.th/ces/2018/ces/rules/rules2/med64.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    loading="lazy"
                    src={handRightIcon}
                    alt="icon download file"
                    style={{ margin: "0 20px", height: "32px" }}
                  />
                  <span style={{ fontWeight: "600" }}>
                    ดูรายละเอียดข้อบังคับฉบับเต็ม
                  </span>
                </a>
              </Detail>

              {departmentData?.rule?.text[0]?.text_1 && (
                <SubHead font="Noto Sans Thai Bold" bottom="10">
                  {departmentData?.rule?.text[0]?.text_1}
                </SubHead>
              )}
              {departmentData?.rule?.text[0]?.text_2 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_2}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_3 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_3}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_4 && (
                <SubDetail top="0" bottom="42" indent="35">
                  {departmentData?.rule?.text[0]?.text_4}
                </SubDetail>
              )}
              <div className="line-style">
                <Line />
              </div>

              {departmentData?.rule?.text[0]?.text_5 && (
                <SubHead font="Noto Sans Thai Bold" top="0" bottom="10">
                  {departmentData?.rule?.text[0]?.text_5}
                </SubHead>
              )}
              {departmentData?.rule?.text[0]?.text_6 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_6}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_7 && (
                <SubDetail top="0" bottom="42" indent="35">
                  {departmentData?.rule?.text[0]?.text_7}
                </SubDetail>
              )}

              <div className="line-style">
                <Line />
              </div>
              {departmentData?.rule?.text[0]?.text_8 && (
                <SubHead font="Noto Sans Thai Bold" top="0" bottom="10">
                  {departmentData?.rule?.text[0]?.text_8}
                </SubHead>
              )}
              <SubDetail top="0" bottom="0" indent="35">
                • การสอบประกอบด้วย 2 ขั้นตอน
              </SubDetail>
              <SubDetail top="0" bottom="0" indent="55">
                - ขั้นตอนที่ 1 ความรู้ทางวิทยาศาสตร์การแพทย์พื้นฐาน
              </SubDetail>
              <SubDetail top="0" bottom="0" indent="55">
                - ขั้นตอนที่ 2 ความรู้ทางวิทยาศาสตร์การแพทย์ชั้นคลินิก
              </SubDetail>
              {departmentData?.rule?.text[0]?.text_10 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_10}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_11 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_11}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_12 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_12}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_13 && (
                <SubDetail top="0" bottom="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_13}
                </SubDetail>
              )}
              {departmentData?.rule?.text[0]?.text_14 && (
                <SubDetail top="0" indent="35">
                  {departmentData?.rule?.text[0]?.text_14}
                </SubDetail>
              )}
            </FixBox>
          </Element>
        )}

        {slang !== "department-medicine" &&
          departmentData?.teaching_management && (
            <Element name={departmentData?.teaching_management?.title}>
              <FixBox bg={ListColor2[slang]}>
                <SubTitle bottom="0">
                  {departmentData?.teaching_management?.title}
                </SubTitle>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    {departmentData?.teaching_management?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0">{item?.text_0}</SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" indent="32">
                              {item?.text_7}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                  <Col span={12} offset={1}>
                    {departmentData?.teaching_management?.image ? (
                      departmentData?.teaching_management?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                    marginBottom: "20px",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                    marginBottom: "20px",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                    marginBottom: "20px",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={fatherMedi}
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {departmentData?.pbl && (
          <Element name={departmentData?.pbl?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.pbl?.image ? (
                  departmentData?.pbl?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.pbl?.title}</SubTitle>
                {departmentData?.pbl?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <TextBold bottom="0">{item?.text_1}</TextBold>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0">{item?.text_2}</SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.license && (
          <Element name={departmentData?.license?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.license?.title}</SubTitle>

                  {departmentData?.license?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.license?.image ? (
                    departmentData?.license?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={fatherMedi}
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-medicine" && departmentData?.support && (
          <Element name={departmentData?.support?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.support?.image ? (
                  departmentData?.support?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.support?.title}</SubTitle>
                {departmentData?.support?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0">{item?.text_0}</SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0">{item?.text_4}</SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.activity && (
          <Element name={departmentData?.activity?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.activity?.title}</SubTitle>

                  {departmentData?.activity?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0">{item?.text_5}</SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.activity?.image ? (
                    departmentData?.activity?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={fatherMedi}
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.evalution && (
          <Element name={departmentData?.evalution?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.evalution?.image ? (
                  departmentData?.evalution?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.evalution?.title}</SubTitle>
                {departmentData?.evalution?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {slang === "department-medicine"
                            ? spliteLink(item?.text_5, "1. Login ในระบบ ")
                            : item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_8}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.study_work && (
          <Element name={departmentData?.study_work?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.study_work?.title}</SubTitle>

                  {departmentData?.study_work?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail indent="32">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail indent="32">{item?.text_1}</SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail indent="32">{item?.text_2}</SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail indent="32">{item?.text_3}</SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.study_work?.image ? (
                    departmentData?.study_work?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={fatherMedi}
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.study && (
          <Element name={departmentData?.study?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <FadeInSection axis="x">
                  <CustomCarousel autoplay bg={ListColor1[slang]}>
                    {departmentData?.study?.image &&
                      departmentData?.study?.image[0]?.image_0 && (
                        <img
                          loading="lazy"
                          src={departmentData?.study?.image[0]?.image_0}
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        />
                      )}
                    {departmentData?.study?.image &&
                      departmentData?.study?.image[0]?.image_1 && (
                        <img
                          loading="lazy"
                          src={departmentData?.study?.image[0]?.image_1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    {departmentData?.study?.image &&
                      departmentData?.study?.image[0]?.image_2 && (
                        <img
                          loading="lazy"
                          src={departmentData?.study?.image[0]?.image_2}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                  </CustomCarousel>
                </FadeInSection>
              </Col>
              <Col span={12} offset={1}>
                <SubTitle>{departmentData?.study?.title}</SubTitle>

                {slang !== "department-agricultural" &&
                slang !== "department-public-health" ? (
                  <>
                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon1} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_0}
                    </SubDetail>

                    {(departmentData?.study?.text[0]?.text_1 ||
                      departmentData?.study?.text[0]?.text_2) && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_1 &&
                          departmentData?.study?.text[0]?.text_1}
                        {departmentData?.study?.text[0]?.text_2 &&
                          departmentData?.study?.text[0]?.text_2}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_3 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_3}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_4 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_4}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_5 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_5}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_6 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_6}
                      </SubDetail>
                    )}

                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon2} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_7}
                    </SubDetail>
                    {departmentData?.study?.text[0]?.text_8 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_8}
                      </SubDetail>
                    )}
                  </>
                ) : slang === "department-public-health" ? (
                  <>
                    <SubHead>{departmentData?.study?.text[0]?.text_0}</SubHead>
                    <SubDetail top="0">
                      {departmentData?.study?.text[0]?.text_1}
                    </SubDetail>

                    <SubHead>{departmentData?.study?.text[0]?.text_2}</SubHead>
                    <SubDetail bottom="0" top="0">
                      {departmentData?.study?.text[0]?.text_3}
                    </SubDetail>

                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon1} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_4}
                    </SubDetail>

                    {(departmentData?.study?.text[0]?.text_5 ||
                      departmentData?.study?.text[0]?.text_6) && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_5 &&
                          departmentData?.study?.text[0]?.text_5}

                        {departmentData?.study?.text[0]?.text_6 &&
                          departmentData?.study?.text[0]?.text_6}

                        {departmentData?.study?.text[0]?.text_7 &&
                          departmentData?.study?.text[0]?.text_7}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_8 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_8}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_9 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_9}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_10 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_10}
                      </SubDetail>
                    )}
                    {departmentData?.study?.text[0]?.text_11 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_11}
                      </SubDetail>
                    )}

                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon2} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_12}
                    </SubDetail>
                    {departmentData?.study?.text[0]?.text_13 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_13}
                      </SubDetail>
                    )}
                  </>
                ) : (
                  <>
                    <SubHead>{departmentData?.study?.text[0]?.text_0}</SubHead>
                    <SubDetail top="0">
                      {departmentData?.study?.text[0]?.text_1}
                    </SubDetail>

                    <SubHead>{departmentData?.study?.text[0]?.text_2}</SubHead>
                    <SubDetail bottom="0" top="0">
                      {departmentData?.study?.text[0]?.text_3}
                    </SubDetail>

                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon1} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_4}
                    </SubDetail>

                    {(departmentData?.study?.text[0]?.text_5 ||
                      departmentData?.study?.text[0]?.text_6) && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_5 &&
                          departmentData?.study?.text[0]?.text_5}
                        {departmentData?.study?.text[0]?.text_6 &&
                          departmentData?.study?.text[0]?.text_6}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_7 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_7}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_8 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_8}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_9 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_9}
                      </SubDetail>
                    )}

                    {departmentData?.study?.text[0]?.text_10 && (
                      <SubDetail indent="32" bottom="0" top="0">
                        {departmentData?.study?.text[0]?.text_10}
                      </SubDetail>
                    )}

                    <SubDetail className="bg-circle">
                      <img loading="lazy" src={learnIcon2} alt="icon circle" />
                      {departmentData?.study?.text[0]?.text_11}
                    </SubDetail>
                  </>
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-social" && departmentData?.information && (
          <Element name={departmentData?.information?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="0" align="center">
                {departmentData?.information?.title}
              </SubTitle>

              {departmentData?.information?.text &&
                departmentData?.information?.text.map((item) => {
                  return (
                    <Row gutter={24} className="row-group">
                      <Col span={12}>
                        {item?.text_0 && (
                          <div style={{ height: "75px" }}>
                            <NameCourse align="center">
                              {item?.text_0}
                            </NameCourse>
                          </div>
                        )}

                        {departmentData?.information?.image &&
                          departmentData?.information?.image.map((item) => {
                            return (
                              <Player
                                poster={item?.image_0}
                                className="img-people"
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            );
                          })}

                        {item?.text_1 && (
                          <SubDetail bottom="0" left="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={11} offset={1}>
                        {item?.text_2 && (
                          <div style={{ height: "75px" }}>
                            <NameCourse align="center">
                              {item?.text_2}
                            </NameCourse>
                          </div>
                        )}

                        {departmentData?.information?.image &&
                          departmentData?.information?.image.map((item) => {
                            return (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                muted
                                playsInline
                                src={item?.image_3}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            );
                          })}

                        {item?.text_3 && (
                          <SubDetail bottom="0" left="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" left="0">
                            {item?.text_9}
                          </SubDetail>
                        )}
                      </Col>
                    </Row>
                  );
                })}
            </FixBox>
          </Element>
        )}

        {slang === "department-social" && departmentData?.q1 && (
          <Element name={departmentData?.q1?.title}>
            <SubTitle top="32" bottom="0" align="center">
              {departmentData?.q1?.title}
            </SubTitle>

            {departmentData?.q1?.text &&
              departmentData?.q1?.text.map((item) => {
                return (
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      {item?.text_0 && (
                        <div style={{ height: "75px" }}>
                          <NameCourse top="0" align="center">
                            {item?.text_0}
                          </NameCourse>
                        </div>
                      )}

                      {rednderImageSplit(
                        departmentData?.q1?.image &&
                          departmentData?.q1?.image[0]?.image_0
                      )}

                      {item?.text_1 && (
                        <SubDetail bottom="0" left="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail bottom="0" top="0" left="0" indent="35">
                          {spliteImage(item?.text_2, "ดูภาพที่เกี่ยวข้อง ")}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail bottom="0" top="0" left="0" indent="35">
                          {spliteImage(item?.text_3, "ดูภาพที่เกี่ยวข้อง ")}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" left="0" indent="35">
                          {spliteImage(item?.text_4, "ดูภาพที่เกี่ยวข้อง ")}
                        </SubDetail>
                      )}

                      {departmentData?.q1_1 &&
                        departmentData?.q1_1?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <SubHead
                                  font="Noto Sans Thai Bold"
                                  left="0"
                                  bottom="0"
                                >
                                  {item?.text_0}
                                </SubHead>
                              )}

                              {item?.text_1 && (
                                <SubDetail
                                  bottom="0"
                                  top="0"
                                  left="0"
                                  indent="35"
                                >
                                  {item?.text_1}
                                </SubDetail>
                              )}
                              {item?.text_2 && (
                                <SubDetail
                                  bottom="0"
                                  top="0"
                                  left="0"
                                  indent="35"
                                >
                                  {item?.text_2}
                                </SubDetail>
                              )}
                              {item?.text_3 && (
                                <SubDetail
                                  bottom="0"
                                  top="0"
                                  left="0"
                                  indent="35"
                                >
                                  {item?.text_3}
                                </SubDetail>
                              )}
                              {item?.text_4 && (
                                <SubDetail
                                  bottom="0"
                                  top="0"
                                  left="0"
                                  indent="35"
                                >
                                  {item?.text_4}
                                </SubDetail>
                              )}
                              {item?.text_5 && (
                                <SubDetail top="0" left="0" indent="35">
                                  {item?.text_5}
                                </SubDetail>
                              )}
                            </>
                          );
                        })}
                    </Col>
                    <Col span={11} offset={1}>
                      {item?.text_5 && (
                        <div style={{ height: "75px" }}>
                          <NameCourse top="0" align="center">
                            {item?.text_5}
                          </NameCourse>
                        </div>
                      )}

                      {rednderImageSplit(
                        departmentData?.q1?.image &&
                          departmentData?.q1?.image[0]?.image_1
                      )}

                      {item?.text_6 && (
                        <SubDetail bottom="0" left="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" bottom="0" left="0">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail top="0" bottom="0" left="0">
                          {item?.text_8}
                        </SubDetail>
                      )}
                      {item?.text_9 && (
                        <SubDetail top="0" bottom="0" left="0">
                          {item?.text_9}
                        </SubDetail>
                      )}
                      {item?.text_10 && (
                        <SubDetail top="0" bottom="0" left="0">
                          {item?.text_10}
                        </SubDetail>
                      )}
                    </Col>
                  </Row>
                );
              })}
          </Element>
        )}

        {slang === "department-social" && departmentData?.q1_2 && (
          <>
            {departmentData?.q1_2?.text && (
              <SubHead
                font="Noto Sans Thai Bold"
                align="center"
                top="50"
                bottom="0"
              >
                {departmentData?.q1_2?.text[0].text_0}
              </SubHead>
            )}

            {departmentData?.q1_2?.text && (
              <SubDetail align="center" top="0">
                {departmentData?.q1_2?.text[0].text_1}
              </SubDetail>
            )}

            {departmentData?.q1_2?.text &&
              departmentData?.q1_2?.text.map((item) => {
                return (
                  <Row gutter={24} className="row-detail-card">
                    <Col span={8}>
                      {item?.text_2 && (
                        <SubHead font="Noto Sans Thai Bold" left="0" bottom="0">
                          {item?.text_2}
                        </SubHead>
                      )}

                      {item?.text_3 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" left="0">
                          {item?.text_7}
                        </SubDetail>
                      )}
                    </Col>
                    <Col span={8}>
                      {item?.text_8 && (
                        <SubHead font="Noto Sans Thai Bold" left="0" bottom="0">
                          {item?.text_8}
                        </SubHead>
                      )}

                      {item?.text_9 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_9}
                        </SubDetail>
                      )}
                      {item?.text_10 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_10}
                        </SubDetail>
                      )}
                      {item?.text_11 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_11}
                        </SubDetail>
                      )}
                      {item?.text_12 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_12}
                        </SubDetail>
                      )}
                      {item?.text_13 && (
                        <SubDetail top="0" left="0">
                          {item?.text_13}
                        </SubDetail>
                      )}
                    </Col>
                    <Col span={8}>
                      {item?.text_14 && (
                        <SubHead font="Noto Sans Thai Bold" left="0" bottom="0">
                          {item?.text_14}
                        </SubHead>
                      )}

                      {item?.text_15 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_15}
                        </SubDetail>
                      )}
                      {item?.text_16 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_16}
                        </SubDetail>
                      )}
                      {item?.text_17 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_17}
                        </SubDetail>
                      )}
                      {item?.text_18 && (
                        <SubDetail bottom="0" top="0" left="0">
                          {item?.text_18}
                        </SubDetail>
                      )}
                      {item?.text_19 && (
                        <SubDetail top="0" left="0">
                          {item?.text_19}
                        </SubDetail>
                      )}
                    </Col>
                  </Row>
                );
              })}
          </>
        )}

        {slang === "department-social" && departmentData?.occupation && (
          <Element name={departmentData?.occupation?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="0" align="center">
                {departmentData?.occupation?.title}
              </SubTitle>

              {departmentData?.occupation?.text &&
                departmentData?.occupation?.text.map((item) => {
                  return (
                    <Row gutter={24} className="row-group">
                      <Col span={12}>
                        {item?.text_0 && (
                          <div style={{ height: "75px" }}>
                            <NameCourse align="center">
                              {item?.text_0}
                            </NameCourse>
                          </div>
                        )}

                        {rednderImageSplit(
                          departmentData?.occupation?.image &&
                            departmentData?.occupation?.image[0]?.image_0
                        )}

                        {item?.text_1 && (
                          <SubDetail bottom="0" left="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail bottom="0" left="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail bottom="0" top="0" left="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <SubDetail bottom="0" top="0" left="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail bottom="0" top="0" left="0">
                            {item?.text_5}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={11} offset={1}>
                        {item?.text_6 && (
                          <div style={{ height: "75px" }}>
                            <NameCourse align="center">
                              {item?.text_6}
                            </NameCourse>
                          </div>
                        )}

                        {rednderImageSplit(
                          departmentData?.occupation?.image &&
                            departmentData?.occupation?.image[0]?.image_1
                        )}

                        {item?.text_7 && (
                          <SubDetail bottom="0" left="0">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_9}
                          </SubDetail>
                        )}
                        {item?.text_10 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_10}
                          </SubDetail>
                        )}
                        {item?.text_11 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_11}
                          </SubDetail>
                        )}
                        {item?.text_12 && (
                          <SubDetail top="0" bottom="0" left="0">
                            {item?.text_12}
                          </SubDetail>
                        )}
                        {item?.text_13 && (
                          <SubDetail top="0" left="0">
                            {item?.text_13}
                          </SubDetail>
                        )}
                      </Col>
                    </Row>
                  );
                })}
            </FixBox>
          </Element>
        )}

        {slang === "department-social" && departmentData?.study && (
          <>
            <Element name={departmentData?.study?.title}>
              <SubTitle top="0" align="center">
                {departmentData?.study?.title}
              </SubTitle>
              {departmentData?.study?.sub_title && (
                <SubDetail indent="32">
                  {departmentData?.study?.sub_title}
                </SubDetail>
              )}
              <Row gutter={24} className="row-detail-card">
                {slang === "department-nursing"
                  ? departmentData?.study?.data.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <CardDetail src={item?.image} detail={item?.detail} />
                        </Col>
                      );
                    })
                  : departmentData?.study?.data &&
                    departmentData?.study?.data.map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <CardDetail src={item?.image} detail={item?.detail} />
                        </Col>
                      );
                    })}
              </Row>
            </Element>
          </>
        )}

        {slang === "department-social" && departmentData?.success && (
          <Element name={departmentData?.success?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.success?.title}</SubTitle>
                  {departmentData?.success?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0 && item?.text_0}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_2 && item?.text_2}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_4 && item?.text_4}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_5 && item?.text_5}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_6 && item?.text_6}
                        </SubDetail>
                        <SubDetail indent="32" top="0">
                          {item?.text_7 && item?.text_7}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.success?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-social" && departmentData?.teacher && (
          <Element name={departmentData?.teacher?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.teacher?.image &&
                  departmentData?.teacher?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                {departmentData?.teacher?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail indent="32" top="0">
                          {item?.text_3}
                        </SubDetail>
                      )}

                      {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {spliteLinkTeacher(
                            item?.text_5,
                            "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ "
                          )}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {spliteLinkPhone(
                            item?.text_6,
                            "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่ "
                          )}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_7}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-social" && departmentData?.study && (
          <>
            {slang !== "department-engineering" &&
            slang !== "department-medicine" ? (
              <Element name={departmentData?.study?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                  {departmentData?.study?.sub_title && (
                    <SubDetail indent="32">
                      {departmentData?.study?.sub_title}
                    </SubDetail>
                  )}
                  <Row gutter={24} className="row-detail-card">
                    {slang === "department-nursing"
                      ? departmentData?.study?.data
                          .slice(1)
                          .map((item, index) => {
                            return (
                              <Col span={8} key={index}>
                                <CardDetail
                                  src={item?.image}
                                  detail={item?.detail}
                                />
                              </Col>
                            );
                          })
                      : departmentData?.study?.data &&
                        departmentData?.study?.data.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <CardDetail
                                src={item?.image}
                                detail={item?.detail}
                              />
                            </Col>
                          );
                        })}
                  </Row>
                </FixBox>
              </Element>
            ) : (
              slang !== "department-medicine" && (
                <Element name={departmentData?.study?.title}>
                  <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                  {departmentData?.study?.sub_title && (
                    <SubDetail indent="32">
                      {departmentData?.study?.sub_title}
                    </SubDetail>
                  )}
                  <Row gutter={24} className="row-detail-card">
                    {departmentData?.study?.data.map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <CardDetail src={item?.image} detail={item?.detail} />
                        </Col>
                      );
                    })}
                  </Row>
                </Element>
              )
            )}
          </>
        )}

        {slang === "department-social" && departmentData?.estimate && (
          <Element name={departmentData?.estimate?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <SubTitle>{departmentData?.estimate?.title}</SubTitle>
                  <SubDetail bottom="0" indent="0">
                    {departmentData?.estimate?.text[0].text_0}
                  </SubDetail>
                  {departmentData?.estimate?.text[0].text_1 && (
                    <SubDetail bottom="0" top="0">
                      {departmentData?.estimate?.text[0].text_1}
                    </SubDetail>
                  )}
                  {departmentData?.estimate?.text[0].text_2 && (
                    <SubDetail bottom="32" top="0">
                      {departmentData?.estimate?.text[0].text_2}
                    </SubDetail>
                  )}
                  {departmentData?.estimate?.text[0].text_3 && (
                    <SubHead>
                      {departmentData?.estimate?.text[0].text_3}
                    </SubHead>
                  )}
                  {departmentData?.estimate?.text[0].text_4 && (
                    <SubDetail bottom="0" top="0">
                      {spliteLink(
                        departmentData?.estimate?.text[0].text_4,
                        "1)  Log in: "
                      )}
                    </SubDetail>
                  )}
                  {departmentData?.estimate?.text[0].text_5 && (
                    <SubDetail bottom="0" top="0">
                      {departmentData?.estimate?.text[0].text_5}
                    </SubDetail>
                  )}
                  {departmentData?.estimate?.text[0].text_6 && (
                    <SubDetail bottom="0" top="0">
                      {departmentData?.estimate?.text[0].text_6}
                    </SubDetail>
                  )}
                  {departmentData?.estimate?.text[0].text_7 && (
                    <SubDetail top="0">
                      {departmentData?.estimate?.text[0].text_7}
                    </SubDetail>
                  )}
                </Col>
                <Col
                  span={11}
                  offset={1}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {slang !== "department-agricultural" ? (
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.estimate?.image &&
                          departmentData?.estimate?.image[0]?.image_0
                            ? departmentData?.estimate?.image[0]?.image_0
                            : engineer1
                        }
                        alt="icon rectangle"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    </FadeInSection>
                  ) : (
                    departmentData?.estimate?.image &&
                    departmentData.estimate.image.map((item) => {
                      return (
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      );
                    })
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.regulations && (
          <Element name={departmentData?.regulations?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <SubTitle align="center" bottom="0">
                    {departmentData?.regulations?.title}
                  </SubTitle>
                  {departmentData?.regulations?.text &&
                    departmentData?.regulations?.text[0]?.text_0 && (
                      <SubDetail align="center" top="0" bottom="0">
                        {departmentData?.regulations?.text[0]?.text_0}
                      </SubDetail>
                    )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <a
                      href="http://web.sut.ac.th/ces/2018/ces/rules/rules2/dent64.pdf"
                      target="_blank"
                      rel="noreferrer"
                      download
                    >
                      <SubDetail top="0">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            loading="lazy"
                            src={iconPDF}
                            alt="icon file pdf"
                            style={{
                              width: "28px",
                              height: "28px",
                              marginRight: "10px",
                            }}
                          />
                          <u>ดูเอกสาร</u>
                        </div>
                      </SubDetail>
                    </a>
                  </div>
                </Col>
                <Col span={12}>
                  <Element name={departmentData?.pay?.title}>
                    <SubTitle align="center" bottom="0">
                      {departmentData?.pay?.title}
                    </SubTitle>
                    {departmentData?.pay?.text &&
                      departmentData?.pay?.text[0]?.text_0 && (
                        <SubDetail align="center" top="0" bottom="0">
                          {departmentData?.pay?.text[0]?.text_0}
                        </SubDetail>
                      )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        href="http://sutgateway.sut.ac.th/admissions2021/ces/fee/B67_2.pdf"
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <SubDetail top="0">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <img
                              loading="lazy"
                              src={iconPDF}
                              alt="icon file pdf"
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                            <u>ดูเอกสาร</u>
                          </div>
                        </SubDetail>
                      </a>
                    </div>
                  </Element>
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.pros && (
          <Element name={departmentData?.pros?.title}>
            {slang === "department-dentistry" ? (
              <>
                <SubTitle top="50">{departmentData?.pros?.title}</SubTitle>
                {departmentData?.pros?.text.map((item) => {
                  return (
                    <>
                      <Row gutter={24} className="row-detail-card">
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_0
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_0}</SubHead>
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_1}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_1
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_2}</SubHead>
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_3}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_2
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_4}</SubHead>
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_5}
                            </SubDetail>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </>
            ) : (
              <FixBox bg={ListColor2[slang]}>
                <SubTitle top="50">{departmentData?.pros?.title}</SubTitle>
                {departmentData?.pros?.text.map((item) => {
                  return (
                    <>
                      <Row gutter={24} className="row-detail-card">
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_0
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_0}</SubHead>
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_1}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_1
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_2}</SubHead>
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_3}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_2
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_4}</SubHead>
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_5}
                            </SubDetail>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </FixBox>
            )}
          </Element>
        )}

        {slang !== "department-dentistry" &&
          slang !== "department-social" &&
          slang !== "department-engineering" &&
          departmentData?.q1 && (
            <Element name={departmentData?.q1?.title}>
              <FixBox bg={ListColor2[slang]}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.q1?.title}</SubTitle>
                    {departmentData?.q1?.text.map((item) => {
                      return slang === "department-degitech" ? (
                        <>
                          {item?.text_0 && (
                            <ListImage
                              listText={item?.text_0}
                              image={iconParagraph}
                              type="list"
                              fontList="Noto Sans Thai"
                            />
                          )}
                          {item?.text_1 && (
                            <ListImage
                              listText={item?.text_1}
                              image={iconParagraph}
                              type="list"
                              fontList="Noto Sans Thai"
                            />
                          )}
                          {item?.text_2 && (
                            <ListImage
                              listText={item?.text_2}
                              image={iconParagraph}
                              type="list"
                              fontList="Noto Sans Thai"
                            />
                          )}
                          {item?.text_3 && (
                            <ListImage
                              listText={item?.text_3}
                              image={iconParagraph}
                              type="list"
                              fontList="Noto Sans Thai"
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0">{item?.text_0}</SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail top="0">{item?.text_3}</SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>

                  <Col span={11} offset={1}>
                    {departmentData?.q1?.image ? (
                      departmentData?.q1?.image.map((item) => {
                        return (
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_3 && (
                              <img
                                loading="lazy"
                                src={item?.image_3}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_4 && (
                              <img
                                loading="lazy"
                                src={item?.image_4}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {slang === "department-dentistry" && departmentData?.q1 && (
          <Element name={departmentData?.q1?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle align="center" top="50" bottom="0">
                {departmentData?.q1?.title}
              </SubTitle>
              <SubDetail align="center" top="0" bottom="0">
                เน้นการเรียนรู้แบบ Active learning
              </SubDetail>
              <Row gutter={24} className="row-detail-card">
                <Col span={8}>
                  <FadeInSection axis="y">
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y1-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y1.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                  </FadeInSection>
                  <SubHead left="0" bottom="0">
                    ชั้นปีที่ 1
                  </SubHead>
                  <SubDetail left="0" top="0" bottom="0">
                    เรียนในกลุ่มรายวิชาศึกษาทั่วไป และวิทยาศาสตร์พื้นฐาน
                  </SubDetail>
                </Col>
                <Col span={8}>
                  <FadeInSection axis="y">
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y2-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y2.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y3-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y3.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                  </FadeInSection>
                  <SubHead left="0" bottom="0">
                    ชั้นปีที่ 2-3
                  </SubHead>
                  <SubDetail left="0" top="0" bottom="0">
                    เรียนรายวิชาด้านวิทยาศาสตร์การแพทย์
                    (ระบบการทำงานของอวัยวะภายในร่างกาย
                    ที่เกี่ยวข้องกับงานทันตกรรม) และวิชาชีพทันตแพทย์พื้นฐาน
                    (สุขภาพช่องปากครอบครัวและชุมชน สุขภาพช่องปากของบุคคลวัยต่าง
                    ๆ ทักษะทางคลินิกทันตกรรม ฯลฯ)
                  </SubDetail>
                </Col>
                <Col span={8}>
                  <FadeInSection axis="y">
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b8%ab%e0%b9%89%e0%b8%ad%e0%b8%87%e0%b9%81%e0%b8%a5%e0%b8%9b%e0%b8%97%e0%b8%b1%e0%b8%99%e0%b8%95%e0%b9%81%e0%b8%9e%e0%b8%97%e0%b8%a2%e0%b9%8c%20%e0%b8%a1%e0%b8%97%e0%b8%aa.-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/lab.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y4-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y4.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                  </FadeInSection>
                  <SubHead left="0" bottom="0">
                    ชั้นปีที่ 4
                  </SubHead>
                  <SubDetail left="0" top="0" bottom="0">
                    เรียนวิชาเฉพาะด้านวิชาชีพทันตแพทย์
                    ทั้งภาคทฤษฎีและฝึกทักษะในห้องปฏิบัติการ
                  </SubDetail>
                </Col>
              </Row>
              <Row gutter={24} className="row-detail-card">
                <Col span={8}>
                  <FadeInSection axis="y">
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y5-crop.png#t=35"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y5.mp4#t=35"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                  </FadeInSection>
                  <SubHead left="0" bottom="0">
                    ชั้นปีที่ 5
                  </SubHead>
                  <SubDetail left="0" top="0" bottom="0">
                    เรียนวิชาเฉพาะทางด้านวิชาชีพทันตแพทย์
                    และฝึกปฏิบัติงานคลินิกหมุนเวียนระหว่างศูนย์สุขภาพช่องปาก
                    รพ.มทส. และในโรงพยาบาลแหล่งฝึก (รพ.มหาราชนครราชสีมา
                    รพ.ชัยภูมิ รพ.บุรีรัมย์ รพ.สุรินทร์ และ
                    รพ.ภูเขียวเฉลิมพระเกียรติ)
                  </SubDetail>
                </Col>
                <Col span={8}>
                  <FadeInSection axis="y">
                    <Player
                      poster={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y6-crop.png"
                      }
                      className="img-people"
                      muted
                      playsInline
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y6.mp4"
                      }
                    >
                      <BigPlayButton position="center" />
                    </Player>
                  </FadeInSection>
                  <SubHead left="0" bottom="0">
                    ชั้นปีที่ 6
                  </SubHead>
                  <SubDetail left="0" top="0" bottom="0">
                    ฝึกประสบการณ์ด้านคลินิก
                    และฝึกปฏิบัติงานในสถานพยาบาลระดับต่าง ๆ
                    เพื่อเรียนรู้ระบบการทำงานในสถานที่จริง
                    รวมถึงเรียนรู้เกี่ยวกับนวัตกรรมวิทยาการสุขภาพช่องปาก
                    และโครงการวิจัย
                  </SubDetail>
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.q2 && (
          <Element name={departmentData?.q2?.title}>
            <SubTitle top="50" align="center" bottom="0">
              {departmentData?.q2?.title}
            </SubTitle>
            <FixBoxLayout>
              <FadeInSection axis="y">
                <CarouselMulti
                  image1={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_0
                      ? departmentData?.q2?.image[0]?.image_0
                      : rectangle1
                  }
                  image2={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_1
                      ? departmentData?.q2?.image[0]?.image_1
                      : rectangle1
                  }
                  image3={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_2
                      ? departmentData?.q2?.image[0]?.image_2
                      : rectangle1
                  }
                  image4={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_3
                      ? departmentData?.q2?.image[0]?.image_3
                      : rectangle1
                  }
                  image5={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_4
                      ? departmentData?.q2?.image[0]?.image_4
                      : rectangle1
                  }
                  image6={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_5
                      ? departmentData?.q2?.image[0]?.image_5
                      : rectangle1
                  }
                  image7={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_6
                      ? departmentData?.q2?.image[0]?.image_6
                      : rectangle1
                  }
                  image8={
                    departmentData?.q2?.image &&
                    departmentData?.q2?.image[0]?.image_7
                      ? departmentData?.q2?.image[0]?.image_7
                      : rectangle1
                  }
                />
              </FadeInSection>
            </FixBoxLayout>

            <Row class="row-group">
              <Col span={12}>
                {departmentData?.q2?.text[0]?.text_0 && (
                  <SubDetail top="0" align="center">
                    {spliteYoutube(
                      departmentData?.q2?.text[0]?.text_0,
                      "ห้องปฏิบัติการพัฒนาทักษะทางคลินิกสุขภาพช่องปาก DENT SUT ",
                      true
                    )}
                  </SubDetail>
                )}
              </Col>
              <Col span={12}>
                {departmentData?.q2?.text[0]?.text_1 && (
                  <SubDetail top="0" align="center">
                    {spliteYoutube(
                      departmentData?.q2?.text[0]?.text_1,
                      "OHC Fun Fun ",
                      true
                    )}
                  </SubDetail>
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.q2 && (
          <Element name={departmentData?.q2?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.q2?.image ? (
                  departmentData?.q2?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.q2?.title}</SubTitle>
                {departmentData?.q2?.text &&
                  departmentData?.q2?.text.map((item) => {
                    return slang === "department-degitech" ? (
                      <>
                        <SubDetail indent="32">
                          {item?.text_0 && item?.text_0}
                        </SubDetail>
                        <SubDetail indent="32">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                      </>
                    ) : (
                      <SubDetail>
                        {item?.text_0 && item?.text_0} <br />
                        {item?.text_1 && item?.text_1} <br />
                        {item?.text_2 && item?.text_2}
                        <br />
                        {item?.text_3 && item?.text_3}
                      </SubDetail>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-social" && departmentData?.q3 && (
          <Element name={departmentData?.q3?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  <SubTitle>{departmentData?.q3?.title}</SubTitle>
                  <SubDetail bottom="0" indent="0">
                    {departmentData?.q3?.text[0].text_0}
                  </SubDetail>
                  {departmentData?.q3?.text[0].text_1 && (
                    <SubDetail bottom="0" top="0">
                      {departmentData?.q3?.text[0].text_1}
                    </SubDetail>
                  )}
                  {departmentData?.q3?.text[0].text_2 && (
                    <SubDetail bottom="0" top="0">
                      {departmentData?.q3?.text[0].text_2}
                    </SubDetail>
                  )}
                  {departmentData?.q3?.text[0].text_3 && (
                    <SubDetail top="0">
                      {departmentData?.q3?.text[0].text_3}
                    </SubDetail>
                  )}
                </Col>
                <Col
                  span={11}
                  offset={1}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {departmentData?.q3?.image &&
                    departmentData.q3.image.map((item) => {
                      return (
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_3 && (
                            <img
                              loading="lazy"
                              src={item?.image_3}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      );
                    })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-social" && departmentData?.q4 && (
          <Element name={departmentData?.q4?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.q4?.image ? (
                  departmentData?.q4?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_3 && (
                            <img
                              loading="lazy"
                              src={item?.image_3}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>

              <Col span={12} offset={1}>
                <SubTitle>{departmentData?.q4?.title}</SubTitle>

                {departmentData?.q4?.text &&
                  departmentData?.q4?.text.map((item) => {
                    return (
                      <>
                        <SubDetail bottom="0">
                          {item?.text_0 && item?.text_0}
                        </SubDetail>

                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0">{item?.text_5}</SubDetail>
                        )}
                      </>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-social" &&
          departmentData?.ac_1_1 &&
          departmentData?.ac_1_2 && (
            <Element name={departmentData?.ac_1_1?.title}>
              <FixBox bg={ListColor2[slang]}>
                <SubTitle align="center" top="50">
                  {departmentData?.ac_1_1?.title}
                </SubTitle>

                {departmentData?.ac_1_1 && (
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      {departmentData?.ac_1_1?.image ? (
                        departmentData?.ac_1_1?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}

                      {departmentData?.ac_1_1?.text[0]?.text_0 && (
                        <>
                          <SubHead top="10" font="Noto Sans Thai Bold">
                            {departmentData?.ac_1_1?.text[0]?.text_0}
                          </SubHead>

                          {departmentData?.ac_1_1?.text[0]?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_1?.text[0]?.text_1}
                            </SubDetail>
                          )}

                          {departmentData?.ac_1_1?.text[0]?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_1?.text[0]?.text_2}
                            </SubDetail>
                          )}
                          {departmentData?.ac_1_1?.text[0]?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_1?.text[0]?.text_3}
                            </SubDetail>
                          )}
                          {departmentData?.ac_1_1?.text[0]?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_1?.text[0]?.text_4}
                            </SubDetail>
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={12}>
                      {departmentData?.ac_1_2?.image ? (
                        departmentData?.ac_1_2?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}

                      {departmentData?.ac_1_2?.text[0]?.text_0 && (
                        <>
                          <SubHead top="10" font="Noto Sans Thai Bold">
                            {departmentData?.ac_1_2?.text[0]?.text_0}
                          </SubHead>

                          {departmentData?.ac_1_2?.text[0]?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_2?.text[0]?.text_1}
                            </SubDetail>
                          )}

                          {departmentData?.ac_1_2?.text[0]?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_2?.text[0]?.text_2}
                            </SubDetail>
                          )}
                          {departmentData?.ac_1_2?.text[0]?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_2?.text[0]?.text_3}
                            </SubDetail>
                          )}
                          {departmentData?.ac_1_2?.text[0]?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {departmentData?.ac_1_2?.text[0]?.text_4}
                            </SubDetail>
                          )}
                        </>
                      )}
                    </Col>
                  </Row>
                )}
              </FixBox>
            </Element>
          )}

        {slang === "department-social" && departmentData?.ac_2 && (
          <Element name={departmentData?.ac_2?.title}>
            <SubTitle top="50" align="center" bottom="0">
              {departmentData?.ac_2?.title}
            </SubTitle>
            <FixBoxLayout>
              <FadeInSection axis="y">
                <CarouselMulti
                  image1={
                    departmentData?.ac_2?.image &&
                    departmentData?.ac_2?.image[0]?.image_0
                      ? departmentData?.ac_2?.image[0]?.image_0
                      : rectangle1
                  }
                  image2={
                    departmentData?.ac_2?.image &&
                    departmentData?.ac_2?.image[0]?.image_1
                      ? departmentData?.ac_2?.image[0]?.image_1
                      : rectangle1
                  }
                  image3={
                    departmentData?.ac_2?.image &&
                    departmentData?.ac_2?.image[0]?.image_2
                      ? departmentData?.ac_2?.image[0]?.image_2
                      : rectangle1
                  }
                />
              </FadeInSection>
            </FixBoxLayout>

            <Row class="row-group">
              <Col span={24}>
                {departmentData?.ac_2?.text[0]?.text_0 && (
                  <SubDetail top="0" indent="32">
                    {departmentData?.ac_2?.text[0]?.text_0}
                  </SubDetail>
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-social" && departmentData?.ac_3 && (
          <Element name={departmentData?.ac_3?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="50" align="center">
                {departmentData?.ac_3?.title}
              </SubTitle>
              {departmentData?.ac_3?.text.map((item) => {
                return (
                  <>
                    <Row gutter={24} className="row-detail-card">
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_0
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>

                        {item?.text_0 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_0}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_1
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_2
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
              {departmentData?.ac_3?.text.map((item) => {
                return (
                  <>
                    <Row gutter={24} className="row-detail-card">
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_3
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>

                        {item?.text_3 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_4
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_4}
                          </SubDetail>
                        )}
                      </Col>
                      <Col span={8}>
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.ac_3?.image &&
                              departmentData?.ac_3?.image[0]?.image_5
                            }
                            alt="ac_3 icon"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </FadeInSection>
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_5}
                          </SubDetail>
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
            </FixBox>
          </Element>
        )}

        {slang === "department-degitech" && departmentData?.q3 && (
          <Element name={departmentData?.q3?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.q3?.text.map((item) => {
                  return (
                    <>
                      <SubDetail bottom="0" top="0">
                        {item?.text_0 && item?.text_0} <br />
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_2 && item?.text_2}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_3 && item?.text_3}
                      </SubDetail>
                      <SubDetail indent="32" top="0">
                        {item?.text_4 && item?.text_4}
                      </SubDetail>
                      <SubDetail indent="32">
                        {item?.text_5 && item?.text_5}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>
              <Col span={12} offset={1}>
                {departmentData?.q3?.image ? (
                  departmentData?.q3?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-degitech" && departmentData?.crepes_model && (
          <Element name={departmentData?.crepes_model?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.crepes_model?.image ? (
                    departmentData?.crepes_model?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.crepes_model?.title}</SubTitle>
                  <SubDetail indent="32">
                    {departmentData?.crepes_model?.text &&
                      departmentData?.crepes_model?.text[0]?.text_0}
                  </SubDetail>
                </Col>
              </Row>

              {departmentData?.crepes && (
                <Row gutter={24} className="row-group crepes">
                  {departmentData?.crepes.map((item, index) => {
                    return (
                      <Col span={8} key={index}>
                        <SubHead align="center" top="40" bottom="40">
                          {item?.title}
                        </SubHead>
                        <BoxImage>
                          <div className="icon-course-structure">
                            <img
                              loading="lazy"
                              src={
                                item?.image
                                  ? item?.image
                                  : listCrePes[item?.title]
                              }
                              alt="icon pencil blue"
                              style={{ width: "133px", height: "131px" }}
                            />
                          </div>

                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <p>{item?.detail}</p>
                          </div>
                        </BoxImage>
                      </Col>
                    );
                  })}
                </Row>
              )}
            </FixBox>
          </Element>
        )}

        {slang === "department-degitech" && departmentData?.coop && (
          <Element name={departmentData?.coop?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12} offset={1}>
                {departmentData?.coop?.image ? (
                  departmentData?.coop?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11}>
                <SubTitle>{departmentData?.coop?.title}</SubTitle>
                {departmentData?.coop?.text &&
                  departmentData?.coop?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="32">
                          {item?.text_0 && item?.text_0} <br />
                        </SubDetail>

                        {item?.text_1 && <SubHead>{item?.text_1}</SubHead>}
                        {(item?.text_2 || item?.text_3 || item?.text_4) && (
                          <SubDetail top="0">
                            {item?.text_2 && item?.text_2} <br />
                            {item?.text_3 && item?.text_3} <br />
                            {item?.text_4 && item?.text_4}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-dentistry" &&
          slang !== "department-degitech" &&
          slang !== "department-social" &&
          departmentData?.q3 && (
            <Element name={departmentData?.q3?.title}>
              <FixBox bg={ListColor2[slang]}>
                <SubTitle>{departmentData?.q3?.title}</SubTitle>

                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    {departmentData?.q3?.text && (
                      <SubDetail className="bg-circle">
                        <img
                          loading="lazy"
                          src={
                            slang === "department-medicine"
                              ? megiIcon
                              : pencilGreen
                          }
                          alt="icon circle pencil green"
                          style={{
                            zIndex: "-1",
                            position: "absolute",
                            left: "-30px",
                            top: "-30px",
                          }}
                        />

                        {departmentData?.q3?.text[0]?.text_0}
                      </SubDetail>
                    )}

                    {departmentData?.q3?.text && (
                      <SubDetail className="bg-circle" top="80">
                        <img
                          loading="lazy"
                          src={
                            slang === "department-medicine"
                              ? megiIcon
                              : pencilGreen
                          }
                          alt="icon circle pencil green"
                          style={{
                            zIndex: "-1",
                            position: "absolute",
                            left: "-30px",
                            top: "-30px",
                          }}
                        />

                        {departmentData?.q3?.text[0]?.text_2}
                      </SubDetail>
                    )}

                    {departmentData?.q3?.text && (
                      <SubDetail className="bg-circle" top="50">
                        <img
                          loading="lazy"
                          src={
                            slang === "department-medicine"
                              ? megiIcon
                              : pencilGreen
                          }
                          alt="icon circle pencil green"
                          style={{
                            zIndex: "-1",
                            position: "absolute",
                            left: "-30px",
                            top: "-30px",
                          }}
                        />

                        {departmentData?.q3?.text[0]?.text_4}
                      </SubDetail>
                    )}
                  </Col>

                  <Col span={11} offset={1}>
                    {departmentData?.q3?.text && (
                      <SubDetail className="bg-circle">
                        <img
                          loading="lazy"
                          src={
                            slang === "department-medicine"
                              ? megiIcon
                              : pencilGreen
                          }
                          alt="icon circle pencil green"
                          style={{
                            zIndex: "-1",
                            position: "absolute",
                            left: "-30px",
                            top: "-30px",
                          }}
                        />

                        {departmentData?.q3?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.q3?.text && (
                      <SubDetail className="bg-circle" top="50">
                        <img
                          loading="lazy"
                          src={
                            slang === "department-medicine"
                              ? megiIcon
                              : pencilGreen
                          }
                          alt="icon circle pencil green"
                          style={{
                            zIndex: "-1",
                            position: "absolute",
                            left: "-30px",
                            top: "-30px",
                          }}
                        />

                        {departmentData?.q3?.text[0]?.text_3}
                      </SubDetail>
                    )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {slang !== "department-dentistry" &&
          slang !== "department-social" &&
          departmentData?.q4 && (
            <Element name={departmentData?.q4?.title}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.q4?.title}</SubTitle>
                  {departmentData?.q4?.text &&
                    departmentData?.q4?.text.map((item) => {
                      return (
                        <>
                          <SubDetail indent="32">
                            {item?.text_0 && item?.text_0} <br />
                          </SubDetail>

                          {item?.text_1 && <SubHead>{item?.text_1}</SubHead>}
                          {(item?.text_2 || item?.text_3 || item?.text_4) && (
                            <SubDetail top="0">
                              {item?.text_2 && item?.text_2} <br />
                              {item?.text_3 && item?.text_3} <br />
                              {item?.text_4 && item?.text_4}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.q4?.image ? (
                    departmentData?.q4?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </Element>
          )}

        {slang === "department-dentistry" &&
          departmentData?.q3 &&
          departmentData?.q4 && (
            <Element name={departmentData?.q3?.title}>
              <Element name={departmentData?.q4?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      <SubTitle>{departmentData?.q3?.title}</SubTitle>
                      {departmentData?.q3?.text &&
                        departmentData?.q3?.text[0] && (
                          <SubDetail indent="32">
                            {departmentData?.q3?.text[0]?.text_0}
                          </SubDetail>
                        )}
                    </Col>
                    <Col span={12} offset={1}>
                      <Element name={departmentData?.q4?.title}>
                        <SubTitle>{departmentData?.q4?.title}</SubTitle>
                      </Element>
                      {departmentData?.q4?.text &&
                        departmentData?.q4?.text[0] && (
                          <>
                            {departmentData?.q4?.text[0]?.text_0 && (
                              <SubDetail indent="32" bottom="0">
                                {departmentData?.q4?.text[0]?.text_0}
                              </SubDetail>
                            )}

                            {departmentData?.q4?.text[0]?.text_1 && (
                              <SubDetail indent="32" top="0">
                                {departmentData?.q4?.text[0]?.text_1}
                              </SubDetail>
                            )}
                          </>
                        )}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            </Element>
          )}

        {slang === "department-dentistry" && departmentData?.result && (
          <Element name={departmentData?.result?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                <SubTitle>{departmentData?.result?.title}</SubTitle>
                <SubHead className="bg-circle" bottom="0">
                  {departmentData?.result?.text[0]?.text_0}
                </SubHead>
                <SubDetail className="bg-circle" bottom="0" top="10">
                  <img
                    loading="lazy"
                    src={learnIcon1}
                    alt="icon circle"
                    style={{
                      zIndex: "-1",
                      position: "absolute",
                      left: "-50px",
                      top: "-20px",
                      width: "133px",
                    }}
                  />
                  {departmentData?.result?.text[0]?.text_1}
                </SubDetail>

                {(departmentData?.result?.text[0]?.text_2 ||
                  departmentData?.result?.text[0]?.text_3) && (
                  <SubDetail bottom="0" top="0">
                    {departmentData?.result?.text[0]?.text_2 &&
                      departmentData?.result?.text[0]?.text_2}
                    <br />
                    {departmentData?.result?.text[0]?.text_3 &&
                      departmentData?.result?.text[0]?.text_3}
                  </SubDetail>
                )}

                <SubDetail className="bg-circle" bottom="0">
                  <img loading="lazy" src={learnIcon2} alt="icon circle" />
                  {departmentData?.result?.text[0]?.text_4}
                </SubDetail>

                {departmentData?.result?.text[0]?.text_5 && (
                  <SubDetail top="0">
                    {departmentData?.result?.text[0]?.text_5}
                  </SubDetail>
                )}

                <SubHead bottom="0">
                  {departmentData?.result?.text[0]?.text_6}
                </SubHead>

                <SubDetail top="10" bottom="0">
                  {departmentData?.result?.text[0]?.text_7}
                </SubDetail>
                <SubDetail top="0" bottom="0">
                  {departmentData?.result?.text[0]?.text_8}
                </SubDetail>
                <SubDetail top="0" bottom="0">
                  {departmentData?.result?.text[0]?.text_9}
                </SubDetail>
                <SubDetail top="0" bottom="0">
                  {departmentData?.result?.text[0]?.text_10}
                </SubDetail>
                <SubDetail top="0" bottom="0">
                  {departmentData?.result?.text[0]?.text_11}
                </SubDetail>
                <SubDetail top="0">
                  {departmentData?.result?.text[0]?.text_12}
                </SubDetail>
              </Col>
              <Col span={11} offset={1}>
                <FadeInSection axis="x">
                  <CustomCarousel autoplay bg={ListColor1[slang]}>
                    {departmentData?.result?.image &&
                      departmentData?.result?.image[0]?.image_0 && (
                        <img
                          loading="lazy"
                          src={departmentData?.result?.image[0]?.image_0}
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        />
                      )}
                    {departmentData?.result?.image &&
                      departmentData?.result?.image[0]?.image_1 && (
                        <img
                          loading="lazy"
                          src={departmentData?.result?.image[0]?.image_1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    {departmentData?.result?.image &&
                      departmentData?.result?.image[0]?.image_2 && (
                        <img
                          loading="lazy"
                          src={departmentData?.result?.image[0]?.image_2}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                  </CustomCarousel>
                </FadeInSection>
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.q5 && (
          <Element name={departmentData?.q5?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  {departmentData?.q5?.image ? (
                    departmentData?.q5?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={11} offset={1}>
                  <SubTitle>{departmentData?.q5?.title}</SubTitle>
                  {departmentData?.q5?.text.map((item) => {
                    return slang === "department-dentistry" ? (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}

                        {item?.text_2 && <SubHead>{item?.text_2}</SubHead>}
                        {item?.text_3 && (
                          <SubDetail bottom="0" indent="32">
                            {spliteLink(item?.text_3, "1) Log in: ")}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_4}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_6}
                          </SubDetail>
                        )}
                      </>
                    ) : (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail bottom="0" top="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.q5 && (
          <Element name={departmentData?.q5?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  {departmentData?.q5?.image ? (
                    departmentData?.q5?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={11} offset={1}>
                  <SubTitle>{departmentData?.q5?.title}</SubTitle>
                  {departmentData?.q5?.text.map((item) => {
                    return slang === "department-dentistry" ? (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && <SubHead>{item?.text_3}</SubHead>}
                        {item?.text_4 && (
                          <SubDetail bottom="0" indent="32">
                            {spliteLink(item?.text_4, "1) Log in: ")}
                          </SubDetail>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_7}
                          </SubDetail>
                        )}
                      </>
                    ) : (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail bottom="0" top="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.q6 && (
          <Element name={departmentData?.q6?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.q6?.title}</SubTitle>
                {departmentData?.q6?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}

                      {item?.text_2 && (
                        <SubDetail top="0" bottom="2" indent="35">
                          {item?.text_2 && item?.text_2}
                        </SubDetail>
                      )}

                      {item?.text_3 && (
                        <SubDetail top="0" bottom="0" indent="20">
                          {spliteYoutube(
                            item?.text_3,
                            "รีวิวมทส. หอพักหญิงมทส. ห้องแอร์ ",
                            true
                          )}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0" indent="20">
                          {spliteYoutube(
                            item?.text_4,
                            "Live in SUT EP.08 : เป็นเด็กหอ มทส. ต้องเจอสิ่งนี้!! ",
                            true
                          )}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.q6?.image ? (
                  departmentData?.q6?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.q6 && (
          <Element name={departmentData?.q6?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.q6?.title}</SubTitle>
                {departmentData?.q6?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      <SubDetail indent="35">
                        {item?.text_2 && item?.text_2}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.q6?.image ? (
                  departmentData?.q6?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.q7 && (
          <Element name={departmentData?.q7?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="50">{departmentData?.q7?.title}</SubTitle>
              <Row className="row-col-3">
                <Col span={8}>
                  {departmentData?.q7?.text[0]?.text_0 && (
                    <SubDetail top="0" bottom="0" indent="20">
                      {spliteYoutube(
                        departmentData?.q7?.text[0]?.text_0,
                        "ข้อบังคับมหาวิทยาลัยเทคโนโลยีสุรนารี ว่าด้วย เครื่องแต่งกายนักศึกษามหาวิทยาลัยเทคโนโลยีสุรนารี พ.ศ. 2545 ",
                        "file"
                      )}
                    </SubDetail>
                  )}
                </Col>
                <Col span={8}>
                  {departmentData?.q7?.text[0]?.text_1 && (
                    <SubDetail top="0" bottom="0" indent="20">
                      {spliteYoutube(
                        departmentData?.q7?.text[0]?.text_1,
                        "แนวปฏิบัติการแต่งกายนักศึกษาทันตแพทย์ชั้นคลินิก ",
                        "file"
                      )}
                    </SubDetail>
                  )}
                </Col>
                <Col span={8}>
                  {departmentData?.q7?.text[0]?.text_2 && (
                    <SubDetail top="0" bottom="0" indent="20">
                      {spliteYoutube(
                        departmentData?.q7?.text[0]?.text_2,
                        "ระเบียบการแต่งกายนักศึกษา คลินิกการเรียนการสอน แหล่งฝึกศูนย์สุขภาพช่องปาก โรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี ",
                        "file"
                      )}
                    </SubDetail>
                  )}
                </Col>
              </Row>
              <Row
                gutter={24}
                className="row-col-3"
                style={{ marginTop: "32px" }}
              >
                <Col span={8}>
                  {departmentData?.q7?.text[0].text_3 && (
                    <NameCourse left="0" bottom="0">
                      {departmentData?.q7?.text[0].text_3}
                    </NameCourse>
                  )}

                  <FadeInSection axis="x">
                    <img
                      loading="lazy"
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a31.png"
                      }
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        margin: "20px 0",
                      }}
                    />
                  </FadeInSection>
                </Col>
                <Col span={8}>
                  {departmentData?.q7?.text[0].text_4 && (
                    <NameCourse left="0" bottom="0">
                      {departmentData?.q7?.text[0].text_4}
                    </NameCourse>
                  )}

                  <FadeInSection axis="x">
                    <CustomCarousel autoplay bg={ListColor1[slang]}>
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a32.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                    </CustomCarousel>
                  </FadeInSection>
                </Col>

                <Col span={8}>
                  {departmentData?.q7?.text[0].text_5 && (
                    <NameCourse left="0" bottom="0">
                      {departmentData?.q7?.text[0].text_5}
                    </NameCourse>
                  )}

                  <FadeInSection axis="x">
                    <CustomCarousel autoplay bg={ListColor1[slang]}>
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%814.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                    </CustomCarousel>
                  </FadeInSection>
                </Col>
              </Row>

              <Row
                gutter={24}
                className="row-col-3"
                style={{
                  marginTop: "32px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Col span={8}>
                  {departmentData?.q7?.text[0].text_6 && (
                    <NameCourse left="0" bottom="0">
                      {departmentData?.q7?.text[0].text_6}
                    </NameCourse>
                  )}

                  <FadeInSection axis="x">
                    <CustomCarousel autoplay bg={ListColor1[slang]}>
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b51.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                      <img
                        loading="lazy"
                        src={
                          "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b52.png"
                        }
                        alt="icon group"
                        style={{
                          borderRadius: "20px",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      />
                    </CustomCarousel>
                  </FadeInSection>
                </Col>

                <Col span={8}>
                  {departmentData?.q7?.text[0].text_7 && (
                    <NameCourse left="0" bottom="0">
                      {departmentData?.q7?.text[0].text_7}
                    </NameCourse>
                  )}

                  <FadeInSection axis="x">
                    <img
                      loading="lazy"
                      src={
                        "http://bulletin.sut.ac.th/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%81%201.png"
                      }
                      alt="icon group"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        margin: "20px 0",
                      }}
                    />
                  </FadeInSection>
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.activity && (
          <Element name={departmentData?.activity?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.activity?.image ? (
                  departmentData?.activity?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={12} offset={1}>
                <SubTitle>{departmentData?.activity?.title}</SubTitle>
                {departmentData?.activity?.text.map((item) => {
                  return (
                    <>
                      <SubDetail bottom="0" indent="35">
                        {item?.text_0 && item?.text_0}
                      </SubDetail>

                      <SubDetail top="0" bottom="0">
                        {item?.text_1 && item?.text_1} <br />
                        {item?.text_2 && item?.text_2}
                        <br />
                        {item?.text_3 && item?.text_3}
                        <br />
                        {item?.text_4 && item?.text_4}
                        <br />
                        {item?.text_5 && item?.text_5}
                        <br />
                        {item?.text_6 && item?.text_6}
                        <br />
                        {item?.text_7 && item?.text_7}
                        <br />
                        {item?.text_8 && item?.text_8}
                        <br />
                        {item?.text_9 && item?.text_9}
                        <br />
                        {item?.text_10 && item?.text_10}
                        <br />
                        {item?.text_11 && item?.text_11}
                        <br />
                        {item?.text_12 && item?.text_12}
                        <br />
                        {item?.text_13 && item?.text_13}
                        <br />
                      </SubDetail>

                      <SubDetail bottom="0">
                        {item?.text_14 && item?.text_14}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.q8 && (
          <Element name={departmentData?.q8?.title}>
            {slang === "department-dentistry" ? (
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.q8?.title}</SubTitle>
                  {departmentData?.q8?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="35">
                          {item?.text_0 && item?.text_0} <br />
                        </SubDetail>
                        <SubDetail indent="35">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.q8?.image ? (
                    departmentData?.q8?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            ) : (
              <FixBox bg={ListColor2[slang]}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.q8?.title}</SubTitle>
                    {departmentData?.q8?.text.map((item) => {
                      return (
                        <>
                          <SubDetail indent="35">
                            {item?.text_0 && item?.text_0} <br />
                          </SubDetail>
                          <SubDetail indent="35">
                            {item?.text_1 && item?.text_1}
                          </SubDetail>
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.q8?.image ? (
                      departmentData?.q8?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </FixBox>
            )}
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.pay && (
          <Element name={departmentData?.pay?.title}>
            <SubTitle top="50">{departmentData?.pay?.title}</SubTitle>
            <Row
              gutter={24}
              className="row-group"
              style={{ marginTop: "20px" }}
            >
              {departmentData?.pay?.data &&
                departmentData?.pay?.data.map((item, index) => {
                  return (
                    <Col span={8} key={index}>
                      <SubHead>{item?.title}</SubHead>
                      {item?.text_0 && (
                        <SubDetail bottom="0">{item?.text_0}</SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail top="0">{item?.text_5}</SubDetail>
                      )}
                    </Col>
                  );
                })}
            </Row>
          </Element>
        )}

        {departmentData?.time && (
          <Element name={departmentData?.time?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  {departmentData?.time?.image ? (
                    departmentData?.time?.image.map((item) => {
                      return (
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={11} offset={1}>
                  <SubTitle>{departmentData?.time?.title}</SubTitle>
                  {departmentData?.time?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && <SubDetail>{item?.text_0}</SubDetail>}
                        <SubDetail>
                          {item?.text_1 && item?.text_1} <br />
                          {item?.text_2 && item?.text_2}
                          <br />
                          {item?.text_3 && item?.text_3} <br />
                          {item?.text_4 && item?.text_4}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-engineering" &&
          slang !== "department-nursing" &&
          slang !== "department-dentistry" &&
          slang !== "department-social" &&
          departmentData?.teacher && (
            <Element name={departmentData?.teacher?.title}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                  {departmentData?.teacher?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail indent="32" bottom="0">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail indent="32" top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail indent="32" top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail indent="32" top="0">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && <SubHead bottom={slang === "department-public-health" ? "10" :"32"}>{item?.text_4}</SubHead>}

                        {slang === "department-public-health" ? (
                          <>
                          <SubDetail  top="0"  bottom="0" indent="32">
                            <div className="link-web public-health">
                            1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ
                              <a
                                href={`http://reg.sut.ac.th/`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>reg.sut.ac.th</u>
                              </a>
                            </div>
                            </SubDetail>
                            <SubDetail top="0" bottom="0" indent="32">
                            <div className="link-web public-health">
                            2) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ
                              <a
                                href={`https://www.sut.ac.th/phone/show_dept.php?id=1100000`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>ดูข้อมูล</u>
                              </a>
                            </div>
                            </SubDetail>
                          </>
                        ) : (
                          <>
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLinkTeacher(
                                  item?.text_5,
                                  "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ "
                                )}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLinkPhone(
                                  item?.text_6,
                                  "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่ "
                                )}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_7}
                              </SubDetail>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.teacher?.image &&
                    departmentData?.teacher?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })}
                </Col>
              </Row>
            </Element>
          )}

        {slang === "department-science" && departmentData?.teacher_1 && (
          <Row gutter={24} className="row-group">
            <Col span={24}>
              {departmentData?.teacher_1?.text.map((item) => {
                return (
                  <>
                    {item?.text_0 && (
                      <SubHead top="20" bottom="20">
                        {item?.text_0}
                      </SubHead>
                    )}
                    {item?.text_1 && (
                      <SubDetail indent="32" top="0" bottom="0">
                        <div className="link-web science">
                          1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ{" "}
                          <a
                            href={`https://reg.sut.ac.th/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u> reg.sut.ac.th</u>
                          </a>
                        </div>
                      </SubDetail>
                    )}
                    {item?.text_2 && (
                      <SubDetail indent="32" top="0" bottom="0">
                        <div className="link-web science">
                          2) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ{" "}
                          <a
                            href={`https://www.sut.ac.th/phone/show_dept.php?id=1010000`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u> ดูข้อมูลติดต่อบุคลากรในสำนักวิชาวิทยาศาสตร์</u>
                          </a>
                        </div>
                      </SubDetail>
                    )}
                    {item?.text_3 && (
                      <SubDetail indent="32" top="0">
                        <div className="link-web science">
                          3) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์
                          หรือสาขาวิชาที่อาจารย์สังกัด{" "}
                          <a
                            href={`https://www.sut.ac.th/2012/phone/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <u> ดูข้อมูลติดต่อของบุคลากร</u>
                          </a>
                        </div>
                      </SubDetail>
                    )}
                  </>
                );
              })}
            </Col>
          </Row>
        )}

        {slang === "department-public-health" && departmentData?.activity && (
          <Element name={departmentData?.activity?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.activity?.image ? (
                    departmentData?.activity?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_3 && (
                              <img
                                loading="lazy"
                                src={item?.image_3}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.activity?.title}</SubTitle>
                  {departmentData?.activity?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail
                            top="0"
                            bottom="0"
                            indent={
                              slang === "department-engineering" ? "32" : "0"
                            }
                          >
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail
                            top="0"
                            bottom="0"
                            indent={
                              slang === "department-engineering" ? "32" : "0"
                            }
                          >
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail
                            top="0"
                            bottom={
                              slang === "department-engineering" ||
                              slang === "department-public-health"
                                ? "0"
                                : "32"
                            }
                            indent={
                              slang === "department-engineering" ? "32" : "0"
                            }
                          >
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {slang !== "department-engineering" ? (
                          slang === "department-public-health" ? (
                            <SubDetail top="0" bottom="0">
                              {item?.text_4}
                            </SubDetail>
                          ) : (
                            item?.text_4 && <SubHead>{item?.text_4}</SubHead>
                          )
                        ) : (
                          item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_4}
                            </SubDetail>
                          )
                        )}
                        {item?.text_5 && (
                          <SubDetail
                            top="0"
                            bottom="0"
                            indent={
                              slang === "department-engineering" ? "32" : "0"
                            }
                          >
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail
                            top="0"
                            bottom="0"
                            indent={
                              slang === "department-engineering" ? "32" : "0"
                            }
                          >
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_9}
                          </SubDetail>
                        )}
                        {item?.text_10 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_10}
                          </SubDetail>
                        )}
                        {item?.text_11 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_11}
                          </SubDetail>
                        )}
                        {item?.text_12 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_12}
                          </SubDetail>
                        )}
                        {item?.text_13 && (
                          <SubDetail top="0">{item?.text_13}</SubDetail>
                        )}
                        {item?.text_14 && (
                          <SubDetail bottom="0">{item?.text_14}</SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.role && (
          <Element name={departmentData?.role?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.role?.title}</SubTitle>
                {departmentData?.role?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_4}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.role?.image &&
                  departmentData?.role?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_3 && (
                            <img
                              loading="lazy"
                              src={item?.image_3}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.studen_system && (
          <Element name={departmentData?.studen_system?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.studen_system?.image ? (
                    departmentData?.studen_system?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.studen_system?.title}</SubTitle>
                  {departmentData?.studen_system?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubTitle bottom="0">{item?.text_0}</SubTitle>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && (
                          <TextBold bottom="0">{item?.text_4}</TextBold>
                        )}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {spliteLinkRegis(item?.text_5, "1) ลงทะเบียนที่ ")}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_6}
                          </SubDetail>
                        )}

                        {item?.text_7 && (
                          <SubTitle bottom="0">{item?.text_7}</SubTitle>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_8}
                          </SubDetail>
                        )}
                        {item?.text_9 && (
                          <SubDetail top="0" bottom="0">
                            <div className="link-web">
                              <a
                                href="http://iph.sut.ac.th/iph-mis/index.php/Main/IPHDocumentLoadPage/1"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>{item?.text_9}</u>
                              </a>
                            </div>
                          </SubDetail>
                        )}
                        {item?.text_10 && (
                          <SubDetail top="0" bottom="0">
                            <div className="link-web">
                              <a
                                href="http://iph.sut.ac.th/iph-mis/index.php/Main/IPHDocumentLoadPage/2"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>{item?.text_10}</u>
                              </a>
                            </div>
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData.teachter_system && (
          <Element name={departmentData.teachter_system?.title}>
            <SubTitle align="center">
              {departmentData.teachter_system?.title}
            </SubTitle>

            <iframe
              title="file"
              style={{ width: "100%", height: "760px", border: "none" }}
              src={
                departmentData.teachter_system?.image &&
                departmentData.teachter_system?.image[0]?.image_1
              }
            />
          </Element>
        )}

        {departmentData.continuous_course && (
          <Element name={departmentData?.continuous_course?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle align="center">
                {departmentData?.continuous_course?.title}
              </SubTitle>

              <Row gutter={24} className="row-detail-card">
                {departmentData?.continuous_course?.text && (
                  <>
                    <Col span={8}>
                      <SubHead bottom="10">
                        {departmentData?.continuous_course?.text[0]?.text_0}
                      </SubHead>
                      <a
                        href="http://bulletin.sut.ac.th/service-sut/image/image_2024/PDF/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%ad%e0%b8%99%e0%b8%b2%e0%b8%a1%e0%b8%b1%e0%b8%a2%e0%b8%aa%e0%b8%b4%e0%b9%88%e0%b8%87%e0%b9%81%e0%b8%a7%e0%b8%94%e0%b8%a5%e0%b9%89%e0%b8%ad%e0%b8%a1%202567.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <SubDetail top="0">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              color: "#EE579C",
                            }}
                          >
                            <img
                              loading="lazy"
                              src={iconPDFPink}
                              alt="icon file pdf"
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                            <u>ดูข้อมูลเพิ่มเติม</u>
                          </div>
                        </SubDetail>
                      </a>
                    </Col>
                    <Col span={8}>
                      <SubHead bottom="10">
                        {departmentData?.continuous_course?.text[0]?.text_1}
                      </SubHead>
                      <a
                        href="http://bulletin.sut.ac.th/service-sut/image/image_2024/PDF/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%ad%e0%b8%99%e0%b8%b2%e0%b8%a1%e0%b8%b1%e0%b8%a2%e0%b9%81%e0%b8%a5%e0%b8%b0%e0%b8%84%e0%b8%a7%e0%b8%b2%e0%b8%a1%e0%b8%9b%e0%b8%a5%e0%b8%ad%e0%b8%94%e0%b8%a0%e0%b8%b1%e0%b8%a2%202567.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <SubDetail top="0">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              color: "#EE579C",
                            }}
                          >
                            <img
                              loading="lazy"
                              src={iconPDFPink}
                              alt="icon file pdf"
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                            <u>ดูข้อมูลเพิ่มเติม</u>
                          </div>
                        </SubDetail>
                      </a>
                    </Col>
                    <Col span={8}>
                      <SubHead bottom="10">
                        {departmentData?.continuous_course?.text[0]?.text_2}
                      </SubHead>
                      <a
                        href="http://bulletin.sut.ac.th/service-sut/image/image_2024/PDF/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b9%82%e0%b8%a0%e0%b8%8a%e0%b8%99%e0%b8%a7%e0%b8%b4%e0%b8%97%e0%b8%a2%e0%b8%b2%e0%b9%81%e0%b8%a5%e0%b8%b0%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%81%e0%b8%b3%e0%b8%ab%e0%b8%99%e0%b8%94%e0%b8%ad%e0%b8%b2%e0%b8%ab%e0%b8%b2%e0%b8%a3%202566.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <SubDetail top="0">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              color: "#EE579C",
                            }}
                          >
                            <img
                              loading="lazy"
                              src={iconPDFPink}
                              alt="icon file pdf"
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                            <u>ดูข้อมูลเพิ่มเติม</u>
                          </div>
                        </SubDetail>
                      </a>
                    </Col>
                  </>
                )}
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData.criteria && (
          <Element name={departmentData?.criteria?.title}>
            <SubTitle align="center">
              {departmentData?.criteria?.title}
            </SubTitle>

            <Row gutter={24} className="row-detail-card" justify="center">
              <Col span={24}>
                <a
                  href="https://iph.sut.ac.th/iph-mis//upload-file/upload_document/IPH_document_3_2024_06_17_17_30_56.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SubDetail top="0">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#EE579C",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        loading="lazy"
                        src={iconPDFPink}
                        alt="icon file pdf"
                        style={{
                          width: "28px",
                          height: "28px",
                          marginRight: "10px",
                        }}
                      />
                      <u>ดูข้อมูลเพิ่มเติม</u>
                    </div>
                  </SubDetail>
                </a>
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.teacher && (
          <Element name={departmentData?.teacher?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  {departmentData?.teacher?.image ? (
                    departmentData?.teacher?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={11} offset={1}>
                  <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                  {departmentData?.teacher?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_5}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" bottom="0">
                            {item?.text_6}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0">{item?.text_7}</SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.q9 && (
          <Element name={departmentData?.q9?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.q9?.title}</SubTitle>
                  {departmentData?.q9?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="35">
                          {item?.text_0 && item?.text_0} <br />
                        </SubDetail>
                        <SubDetail indent="35">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.q9?.image ? (
                    departmentData?.q9?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-dentistry" &&
          departmentData?.q10 &&
          departmentData?.q11 && (
            <Element name={departmentData?.q10?.title}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.q10?.title}</SubTitle>
                  {departmentData?.q10?.text &&
                    departmentData?.q10?.text[0] && (
                      <SubDetail>
                        {departmentData?.q10?.text[0]?.text_0} <br />
                        {departmentData?.q10?.text[0]?.text_1} <br />
                        {departmentData?.q10?.text[0]?.text_2} <br />
                        {departmentData?.q10?.text[0]?.text_3}
                      </SubDetail>
                    )}
                  <Element name={departmentData?.q11?.title}>
                    <SubTitle>{departmentData?.q11?.title}</SubTitle>
                  </Element>
                  {departmentData?.q11?.text &&
                    departmentData?.q11?.text[0] && (
                      <SubDetail>
                        {departmentData?.q11?.text[0]?.text_0}
                        <br />
                        {departmentData?.q11?.text[0]?.text_1}
                        <br />
                        {departmentData?.q11?.text[0]?.text_2}
                        <br />
                        {departmentData?.q11?.text[0]?.text_3}
                      </SubDetail>
                    )}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.q9?.image ? (
                    departmentData?.q9?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </Element>
          )}

        {departmentData?.project && slang === "department-dentistry" && (
          <Element name={departmentData?.project?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11} offset={1}>
                  <FadeInSection axis="x">
                    {departmentData?.project?.image ? (
                      <img
                        loading="lazy"
                        src={
                          departmentData?.project?.image[0]?.image_0 &&
                          departmentData?.project?.image[0]?.image_0
                        }
                        alt="icon rectangle"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    ) : (
                      <img
                        loading="lazy"
                        src={rectangle2}
                        alt="icon rectangle"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </FadeInSection>
                </Col>
                <Col span={12}>
                  <SubTitle>{departmentData?.project?.title}</SubTitle>
                  <SubDetail>
                    {departmentData?.project?.text[0]?.text_0}
                  </SubDetail>
                  <SubHead>
                    <a
                      href="https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
                      target="_blank"
                      rel="noreferrer"
                      download
                    >
                      <img
                        src={downloadIcon}
                        alt="icon download file"
                        loading="lazy"
                      />
                      ดาวน์โหลดแบบฟอร์ม
                    </a>
                  </SubHead>
                  {departmentData?.project?.text[0]?.text_1 && (
                    <SubDetail indent="32">
                      {departmentData?.project?.text[0]?.text_1}
                    </SubDetail>
                  )}
                  {departmentData?.project?.text[0]?.text_2 && (
                    <SubDetail indent="32">
                      {departmentData?.project?.text[0]?.text_2}
                    </SubDetail>
                  )}
                  {departmentData?.project?.text[0]?.text_3 && (
                    <TextNote>
                      {departmentData?.project?.text[0]?.text_3}
                    </TextNote>
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.criterion && departmentData?.criterion1 && (
          <Element name={departmentData?.criterion?.title}>
            <SubTitle>{departmentData?.criterion?.title}</SubTitle>
            <Row
              gutter={24}
              className="row-group"
              style={{ marginTop: "10px" }}
            >
              <Col span={11}>
                {departmentData?.criterion?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && <SubHead>{item?.text_0}</SubHead>}
                      {item?.text_1 && (
                        <TextBold bottom="0">{item?.text_1}</TextBold>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <TextBold bottom="0" top="0">
                          {item?.text_3}
                        </TextBold>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_8}
                        </SubDetail>
                      )}
                      {item?.text_9 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_9}
                        </SubDetail>
                      )}
                      {item?.text_10 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_10}
                        </SubDetail>
                      )}
                      {item?.text_11 && (
                        <SubDetail top="0" indent="35">
                          {item?.text_11}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.criterion1?.text.map((item) => {
                  return (
                    <>
                      {departmentData?.criterion1?.title && (
                        <SubHead>{departmentData?.criterion1?.title}</SubHead>
                      )}
                      {item?.text_0 && (
                        <TextBold bottom="0">{item?.text_0}</TextBold>
                      )}
                      {item?.text_1 && (
                        <TextBold bottom="0" top="0">
                          {item?.text_1}
                        </TextBold>
                      )}
                      {item?.text_2 && (
                        <TextBold bottom="0" top="0">
                          {item?.text_2}
                        </TextBold>
                      )}
                      {item?.text_3 && (
                        <TextBold bottom="0" top="0">
                          {item?.text_3}
                        </TextBold>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_4}
                        </SubDetail>
                      )}

                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" bottom="0">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail top="0">{item?.text_8}</SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-nursing" && departmentData?.teacher && (
          <Element name={departmentData?.teacher?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                  {departmentData?.teacher?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && <TextNote>{item?.text_4}</TextNote>}
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.teacher?.image ? (
                    departmentData?.teacher?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_3 && (
                              <img
                                loading="lazy"
                                src={item?.image_3}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.estermate && (
          <Element name={departmentData?.estermate?.title}>
            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.estermate?.image ? (
                  departmentData?.estermate?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_3 && (
                            <img
                              loading="lazy"
                              src={item?.image_3}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.estermate?.title}</SubTitle>
                {departmentData?.estermate?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && <SubHead>{item?.text_3}</SubHead>}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {slang === "department-nursing"
                            ? spliteLink(item?.text_4, "1) Log in: ")
                            : item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_7}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.vow && (
          <Element name={departmentData?.vow?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.vow?.title}</SubTitle>
                  {departmentData?.vow?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="35">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail bottom="0" top="0" indent="35">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" indent="35">
                            {item?.text_2}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
                <Col span={12} offset={1}>
                  {departmentData?.vow?.image ? (
                    departmentData?.vow?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.song && (
          <Element name={departmentData?.song?.title}>
            <Row gutter={24} className="row-group">
              <Col span={24}>
                <SubTitle align="center">
                  {departmentData?.song?.title}
                </SubTitle>
                {departmentData?.song?.text.map((item) => {
                  return (
                    <>
                      <SubDetail align="center">
                        {item?.text_0 && item?.text_0} <br />
                        {item?.text_1 && item?.text_1} <br />
                        {item?.text_2 && item?.text_2}
                        <br />
                        {item?.text_3 && item?.text_3} <br />
                        {item?.text_4 && item?.text_4} <br />
                        {item?.text_5 && item?.text_5} <br />
                        {item?.text_6 && item?.text_6} <br />
                        {item?.text_7 && item?.text_7} <br />
                        {item?.text_8 && item?.text_8} <br />
                        {item?.text_9 && item?.text_9} <br />
                        {item?.text_10 && item?.text_10} <br />
                        {item?.text_11 && item?.text_11} <br />
                        {item?.text_12 && item?.text_12} <br />
                        {item?.text_13 && item?.text_13} <br />
                        {item?.text_14 && item?.text_14} <br />
                        {item?.text_15 && item?.text_15} <br />
                        {item?.text_16 && item?.text_16} <br />
                        {item?.text_17 && item?.text_17}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-medicine" &&
        slang !== "department-public-health" &&
        slang !== "department-degitech" &&
        departmentData?.about ? (
          <Element name={departmentData?.about?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.about?.title}</SubTitle>
                  {departmentData?.about?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0 && item?.text_0}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_2 && item?.text_2}
                        </SubDetail>
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_3 && item?.text_3}
                        </SubDetail>
                        <SubDetail indent="32" top="0">
                          {item?.text_4 && item?.text_4}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.about?.image ? (
                    departmentData?.about?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        ) : (
          slang !== "department-public-health" &&
          slang !== "department-degitech" && (
            <Element name={departmentData?.about?.title}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.about?.title}</SubTitle>
                  {departmentData?.about?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail indent="32" bottom="0">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail indent="32" top="0" bottom="0">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail indent="32" top="0" bottom="0">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail indent="32" top="0">
                            {item?.text_3}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.about?.image &&
                    departmentData?.about?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })}
                </Col>
              </Row>
            </Element>
          )
        )}

        {slang === "department-degitech" && departmentData?.about && (
          <Element name={departmentData?.about?.title}>
            <SubTitle>{departmentData?.about?.title}</SubTitle>
            <SubDetail indent="32" top="0">
              {departmentData?.about?.text &&
                departmentData?.about?.text[0]?.text_0}
            </SubDetail>

            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.nature?.image &&
                  departmentData?.nature?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.nature?.title}</SubTitle>

                {departmentData?.nature?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail indent="32" top="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>

            <Row gutter={24} className="row-group">
              <Col span={12}>
                {departmentData?.dc?.image &&
                  departmentData?.dc?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
              <Col span={11} offset={1}>
                <SubTitle>{departmentData?.dc?.title}</SubTitle>

                {departmentData?.dc?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_7}
                        </SubDetail>
                      )}
                      {item?.text_8 && (
                        <SubDetail indent="32" top="0" bottom="0">
                          {item?.text_8}
                        </SubDetail>
                      )}
                      {item?.text_9 && (
                        <SubDetail indent="32" top="0">
                          {item?.text_9}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-degitech" && departmentData?.activity && (
          <Element name={departmentData?.activity?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle align="center" bottom="-40">
                {departmentData?.activity?.title}
              </SubTitle>

              <FixBoxLayout>
                <Row>
                  {departmentData?.activity?.image &&
                    departmentData?.activity?.image.map((item) => {
                      return (
                        <>
                          <Col span={8}>
                            <FadeInSection axis="y">
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="branch"
                                style={{ maxWidth: "100%", height: "auto" }}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={8}>
                            <FadeInSection axis="y">
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="branch"
                                style={{ maxWidth: "100%", height: "auto" }}
                              />
                            </FadeInSection>
                          </Col>

                          <Col span={8}>
                            <FadeInSection axis="y">
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="branch"
                                style={{ maxWidth: "100%", height: "auto" }}
                              />
                            </FadeInSection>
                          </Col>
                        </>
                      );
                    })}
                </Row>
              </FixBoxLayout>
            </FixBox>
          </Element>
        )}

        {departmentData?.about1 && (
          <Element name={departmentData?.about1?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={12}>
                  {departmentData?.about1?.image ? (
                    departmentData?.about1?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={11} offset={1}>
                  <SubTitle>{departmentData?.about1?.title}</SubTitle>
                  {departmentData?.about1?.text.map((item) => {
                    return (
                      <SubDetail>
                        {item?.text_0 && item?.text_0} <br />
                        {item?.text_1 && item?.text_1} <br />
                        {item?.text_2 && item?.text_2}
                        <br />
                        {item?.text_3 && item?.text_3}
                        <br />
                        {item?.text_4 && item?.text_4}
                        <br />
                        {item?.text_5 && item?.text_5}
                        <br />
                        {item?.text_6 && item?.text_6}
                        <br />
                        {item?.text_7 && item?.text_7}
                        <br />
                        {item?.text_8 && item?.text_8}
                        <br />
                        {item?.text_9 && item?.text_9}
                        <br />
                        {item?.text_10 && item?.text_10}
                        <br />
                        {item?.text_11 && item?.text_11}
                        <br />
                        {item?.text_12 && item?.text_12}
                        <br />
                        {item?.text_13 && item?.text_13}
                        <br />
                        {item?.text_14 && item?.text_14}
                        <br />
                        {item?.text_15 && item?.text_15}
                      </SubDetail>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-medicine" && departmentData?.about2 && (
          <Element name={departmentData?.about2?.title}>
            <SubTitle top="50">{departmentData?.about2?.title}</SubTitle>
            <Row
              gutter={24}
              className="row-group"
              style={{ marginTop: "20px" }}
            >
              <Col span={8}>
                {departmentData?.about2?.text &&
                  departmentData?.about2?.text[0].text_0 &&
                  renderDetailLink(
                    departmentData?.about2?.text[0].text_0,
                    departmentData?.about2?.text[0].text_0
                  )}

                {departmentData?.about2?.text &&
                  departmentData?.about2?.text[0].text_3 &&
                  renderDetailLink(
                    departmentData?.about2?.text[0].text_3,
                    departmentData?.about2?.text[0].text_3
                  )}
              </Col>
              <Col span={8}>
                {departmentData?.about2?.text &&
                  departmentData?.about2?.text[0].text_1 &&
                  renderDetailLink(
                    departmentData?.about2?.text[0].text_1,
                    departmentData?.about2?.text[0].text_1
                  )}

                {departmentData?.about2?.text &&
                  departmentData?.about2?.text[0].text_4 &&
                  renderDetailLink(
                    departmentData?.about2?.text[0].text_4,
                    departmentData?.about2?.text[0].text_4
                  )}
              </Col>
              <Col span={8}>
                {departmentData?.about2?.text &&
                  departmentData?.about2?.text[0].text_2 &&
                  renderDetailLink(
                    departmentData?.about2?.text[0].text_2,
                    departmentData?.about2?.text[0].text_2
                  )}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-medicine" && departmentData?.about3 && (
          <Element name={departmentData?.about2?.text[0].text_0}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.about3?.text &&
                  departmentData?.about3?.text[0] && (
                    <>
                      <SubDetail indent="35">
                        {departmentData?.about3?.text[0].text_0}
                      </SubDetail>
                      <SubHead>
                        {departmentData?.about3?.text[0].text_1}
                      </SubHead>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_2}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_3}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_4}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_5}
                      </SubDetail>
                      <SubDetail top="0">
                        {departmentData?.about3?.text[0].text_6}
                      </SubDetail>

                      <SubHead>
                        {departmentData?.about3?.text[0].text_7}
                      </SubHead>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_8}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_9}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_10}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_11}
                      </SubDetail>
                      <SubDetail top="0" bottom="0">
                        {departmentData?.about3?.text[0].text_12}
                      </SubDetail>
                    </>
                  )}
              </Col>

              <Col span={12} offset={1}>
                <img
                  loading="lazy"
                  src={rectangle1}
                  alt="icon group"
                  style={{ borderRadius: "20px", width: "100%" }}
                />
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.question && (
          <Element name={departmentData?.question?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle>{departmentData?.question?.title}</SubTitle>

              {departmentData?.question?.type &&
                departmentData?.question?.type.length >= 0 &&
                departmentData?.question?.type.map((item, index, row) => {
                  return (
                    <div key={`title-${index}`}>
                      <Row className="row-top">
                        <Col span={24}>
                          {item?.title && <TextHead>{item?.title}</TextHead>}
                        </Col>
                        <Col span={24}>
                          {item?.question.length >= 0 &&
                            item?.question.map((item, index) => {
                              return (
                                <QuestBlog
                                  colorQuest={ListColorQ[slang]}
                                  top="40"
                                  key={`quest-${index}`}
                                  headText={item?.question}
                                  ansTextFirst={
                                    item?.answers ? item?.answers : ""
                                  }
                                  ansTextSecon={
                                    item?.answer_1 ? item?.answer_1 : ""
                                  }
                                  ansTextThird={
                                    item?.answer_2 ? item?.answer_2 : ""
                                  }
                                />
                              );
                            })}
                        </Col>
                      </Row>
                      {index + 1 !== row.length && (
                        <div className="line-style">
                          <Line />
                        </div>
                      )}
                    </div>
                  );
                })}

              <SubDetail align="center">
                <div className="link-web">
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeqIE5oMjijiR7NHhtuytZ7oKcuvVZGvIGCbW1reqk8dw_QwQ/viewform"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>
                      ช่องทางรับฟังความคิดเห็น/ รับเรื่องร้องเรียน/ ถาม-ตอบ(Q&A)
                    </u>
                  </a>
                </div>
              </SubDetail>
              <div style={{ width: "100%", display: "flex" }}>
                <Line />
              </div>
            </FixBox>
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.question && (
          <Element name={departmentData?.question?.title}>
            <SubTitle>{departmentData?.question?.title}</SubTitle>

            {departmentData?.question?.type &&
              departmentData?.question?.type.length >= 0 &&
              departmentData?.question?.type.map((item, index, row) => {
                return (
                  <div key={`title-${index}`}>
                    <Row className="row-top">
                      <Col span={24}>
                        {item?.title && <TextHead>{item?.title}</TextHead>}
                      </Col>
                      <Col span={24}>
                        {item?.question.length >= 0 &&
                          item?.question.map((item, index) => {
                            return (
                              <QuestBlog
                                colorQuest={ListColorQ[slang]}
                                top="40"
                                key={`quest-${index}`}
                                headText={item?.question}
                                ansTextFirst={
                                  item?.answers ? item?.answers : ""
                                }
                                ansTextSecon={
                                  item?.answer_1 ? item?.answer_1 : ""
                                }
                                ansTextThird={
                                  item?.answer_2 ? item?.answer_2 : ""
                                }
                              />
                            );
                          })}
                      </Col>
                    </Row>
                    {index + 1 !== row.length && (
                      <div className="line-style">
                        <Line />
                      </div>
                    )}
                  </div>
                );
              })}
          </Element>
        )}

        {slang === "department-medicine" && departmentData?.qrcode && (
          <Element name={departmentData?.qrcode?.title}>
            <SubTitle align="center">{departmentData?.qrcode?.title}</SubTitle>
            {departmentData?.qrcode?.image && (
              <img
                loading="lazy"
                src={departmentData?.qrcode?.image[0]?.image_0}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: "40px",
                }}
                alt="qrcode"
              />
            )}
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "center",
              }}
            >
              <img
                loading="lazy"
                src={iconScanner}
                style={{ width: "16px", marginRight: "5px" }}
                alt="scanner"
              />
              <TextScan>
                <div className="link-qr">
                  สแกน เพื่อไปยังเว็บไซต์หลักของสำนัก หรือ
                  <a
                    href={`http://imdata.sut.ac.th/im-sut/index.php`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>คลิกที่นี่</u>
                  </a>
                </div>
              </TextScan>
            </div>
          </Element>
        )}

        {slang === "department-dentistry" && (
          <Element name="8 เทคนิคเรียนทันตแพทย์ยังไงให้ปัง !!!">
            <FixBoxLayout>
              <SubTitle align="center" className="title-tech">
                8 เทคนิคเรียนทันตแพทย์ยังไงให้ปัง !!!
              </SubTitle>
              <FadeInSection axis="y">
                <CarouselMulti
                  image1={tech1}
                  image2={tech2}
                  image3={tech3}
                  image4={tech4}
                  image5={tech5}
                  image6={tech6}
                  image7={tech7}
                  image8={tech8}
                />
              </FadeInSection>
            </FixBoxLayout>
          </Element>
        )}

        {slang === "department-dentistry" && departmentData?.should_contact && (
          <Element name="เรื่องนี้ต้องติดต่อใคร">
            <SubTitle align="center" className="title-tech">
              เรื่องนี้ต้องติดต่อใคร
            </SubTitle>
            <SubBold align="center">ภายในสำนักวิชาทันตแพทยศาสตร์</SubBold>
            <Row className="row-name-course" gutter={[24, 24]}>
              {departmentData?.should_contact && (
                <>
                  {departmentData?.should_contact[0] && (
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[0]?.image}
                          title={departmentData?.should_contact[0]?.title}
                          detail={departmentData?.should_contact[0]?.detail}
                          link={departmentData?.should_contact[0]?.link_1}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                  {departmentData?.should_contact[1] && (
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[1]?.image}
                          title={departmentData?.should_contact[1]?.title}
                          detail={departmentData?.should_contact[1]?.detail}
                          link={departmentData?.should_contact[1]?.link_1}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                  {departmentData?.should_contact[2] && (
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[2]?.image}
                          title={departmentData?.should_contact[2]?.title}
                          detail={departmentData?.should_contact[2]?.detail}
                          link={departmentData?.should_contact[2]?.link_1}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                </>
              )}
            </Row>

            <SubBold align="center" top="20">
              ภายในมหาวิทยาลัย
            </SubBold>
            <Row className="row-name-course" gutter={[24, 24]}>
              {departmentData?.should_contact && (
                <>
                  {departmentData?.should_contact[3] && (
                    <Col span={8}>
                      <FadeInSection axis="x">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[3]?.image}
                          title={departmentData?.should_contact[3]?.title}
                          detail={departmentData?.should_contact[3]?.detail}
                          link={departmentData?.should_contact[3]?.link_1}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                  {departmentData?.should_contact[4] && (
                    <Col span={8}>
                      <FadeInSection axis="x">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[4]?.image}
                          title={departmentData?.should_contact[4]?.title}
                          detail={departmentData?.should_contact[4]?.detail}
                          link={departmentData?.should_contact[4]?.link_1}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                  {departmentData?.should_contact[5] && (
                    <Col span={8}>
                      <FadeInSection axis="x">
                        <CardText
                          colorText="#774f9f"
                          image={departmentData?.should_contact[5]?.image}
                          title={departmentData?.should_contact[5]?.title}
                          detail={departmentData?.should_contact[5]?.detail}
                          link1={departmentData?.should_contact[5]?.link_1}
                          link2={departmentData?.should_contact[5]?.link_2}
                          link3={departmentData?.should_contact[5]?.link_3}
                        />
                      </FadeInSection>
                    </Col>
                  )}
                </>
              )}
            </Row>
          </Element>
        )}

        {departmentData?.how && (
          <Element name={departmentData?.how?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.how?.image.map((item) => {
                  return (
                    <FadeInSection axis="x">
                      <CustomCarousel autoplay bg={ListColor1[slang]}>
                        {item?.image_0 && (
                          <img
                            loading="lazy"
                            src={item?.image_0}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        {item?.image_1 && (
                          <img
                            loading="lazy"
                            src={item?.image_1}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        {item?.image_2 && (
                          <img
                            loading="lazy"
                            src={item?.image_2}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                      </CustomCarousel>
                    </FadeInSection>
                  );
                })}
              </Col>
              <Col span={12} offset={1}>
                <SubTitle>{departmentData?.how?.title}</SubTitle>
                {departmentData?.how?.text.map((item) => {
                  return (
                    <>
                      <SubDetail indent="32" bottom="0">
                        {item?.text_0 && item?.text_0}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_1 && item?.text_1}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_2 && item?.text_2}
                      </SubDetail>
                      <SubDetail indent="32" top="0" bottom="0">
                        {item?.text_3 && item?.text_3}
                      </SubDetail>
                      <SubDetail indent="32" top="0">
                        {item?.text_4 && item?.text_4}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>
            </Row>
          </Element>
        )}

        {slang !== "department-social" && departmentData?.information && (
          <Element name={departmentData?.information?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.information?.title}</SubTitle>
                  {departmentData?.information?.text.map((item) => {
                    return (
                      <SubDetail indent="32">
                        {item?.text_0 && item?.text_0} <br />
                      </SubDetail>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.information?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang !== "department-social" && departmentData?.occupation && (
          <Element name={departmentData?.occupation?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                {departmentData?.occupation?.image.map((item) => {
                  return (
                    <FadeInSection axis="x">
                      <CustomCarousel autoplay bg={ListColor1[slang]}>
                        {item?.image_0 && (
                          <img
                            loading="lazy"
                            src={item?.image_0}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        {item?.image_1 && (
                          <img
                            loading="lazy"
                            src={item?.image_1}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        {item?.image_2 && (
                          <img
                            loading="lazy"
                            src={item?.image_2}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                        {item?.image_03 && (
                          <img
                            loading="lazy"
                            src={item?.image_3}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                      </CustomCarousel>
                    </FadeInSection>
                  );
                })}
              </Col>
              <Col span={12} offset={1}>
                <SubTitle>{departmentData?.occupation?.title}</SubTitle>
                {departmentData?.occupation?.text.map((item) => {
                  return (
                    <>
                      <SubDetail indent="32" bottom="0">
                        {item?.text_0 && item?.text_0}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_1 && item?.text_1}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_2 && item?.text_2}
                      </SubDetail>
                      <SubDetail indent="32" bottom="0" top="0">
                        {item?.text_3 && item?.text_3}
                      </SubDetail>
                      <SubDetail indent="32" top="0">
                        {item?.text_4 && item?.text_4}
                      </SubDetail>
                    </>
                  );
                })}
              </Col>
            </Row>
            {departmentData?.occupation?.text[0].text_5 && (
              <SubDetail indent="32" top="0">
                {departmentData?.occupation?.text[0].text_5}
              </SubDetail>
            )}
          </Element>
        )}

        {slang !== "department-social" && departmentData?.success && (
          <Element name={departmentData?.success?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <SubTitle>{departmentData?.success?.title}</SubTitle>
                  {departmentData?.success?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="32" bottom="0">
                          {item?.text_0 && item?.text_0}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_1 && item?.text_1}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_2 && item?.text_2}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_4 && item?.text_4}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_5 && item?.text_5}
                        </SubDetail>
                        <SubDetail indent="32" bottom="0" top="0">
                          {item?.text_6 && item?.text_6}
                        </SubDetail>
                        <SubDetail indent="32" top="0">
                          {item?.text_7 && item?.text_7}
                        </SubDetail>
                      </>
                    );
                  })}
                </Col>

                <Col span={12} offset={1}>
                  {departmentData?.success?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.english && (
          <Element name={departmentData?.english?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <FadeInSection axis="y">
                    <img
                      loading="lazy"
                      src={
                        departmentData?.english?.image
                          ? departmentData?.english?.image[0]?.image_0
                          : sciTable
                      }
                      alt="table"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  </FadeInSection>
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.english?.title}</SubTitle>

                  {departmentData?.english?.text.map((item, index) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail indent="32">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail indent="32">{item?.text_1}</SubDetail>
                        )}

                        {(item?.text_2 || item?.text_3 || item?.text_4) && (
                          <SubDetail>
                            {item?.text_2 && item?.text_2}
                            <br />
                            {item?.text_3 && item?.text_3}
                            <br />
                            {item?.text_4 && item?.text_4}
                          </SubDetail>
                        )}

                        {(item?.text_5 || item?.text_6 || item?.text_7) && (
                          <SubDetail>
                            {item?.text_5 && item?.text_5}
                            <br />
                            {item?.text_6 && item?.text_6}
                            <br />
                            {item?.text_7 && item?.text_7}
                          </SubDetail>
                        )}

                        {(item?.text_8 || item?.text_9 || item?.text_10) && (
                          <SubDetail>
                            {item?.text_8 && item?.text_8}
                            <br />
                            {item?.text_9 && item?.text_9}
                            <br />
                            {item?.text_10 && item?.text_10}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.plane && (
          <Element name={departmentData?.plane?.title}>
            <FixBox
              bg={slang === "department-science" ? ListColor2[slang] : ""}
            >
              <SubTitle top="50">{departmentData?.plane?.title}</SubTitle>
              {departmentData?.plane?.text.map((item, index) => {
                return (
                  <>
                    <SubDetail>{item?.text_0}</SubDetail>

                    <Row gutter={24} className="row-detail-card">
                      {!item?.text_5 ? (
                        <>
                          <Col span={8}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_0
                                }
                                text={item?.text_1}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={8}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_1
                                }
                                text={item?.text_2}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={8}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_2
                                }
                                text={item?.text_3}
                              />
                            </FadeInSection>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col span={6}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_0
                                }
                                text={item?.text_1}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={6}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_1
                                }
                                text={item?.text_2}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={6}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_2
                                }
                                text={item?.text_3}
                              />
                            </FadeInSection>
                          </Col>
                          <Col span={6}>
                            <FadeInSection axis="y">
                              <CardImage
                                src={
                                  departmentData?.plane?.image &&
                                  departmentData?.plane?.image[0].image_3
                                    ? departmentData?.plane?.image[0].image_3
                                    : departmentData?.plane?.image[0].image_2
                                }
                                text={item?.text_5}
                              />
                            </FadeInSection>
                          </Col>
                        </>
                      )}
                    </Row>

                    <TextNote>{item?.text_4}</TextNote>
                  </>
                );
              })}
            </FixBox>
          </Element>
        )}

        {slang !== "department-dentistry" && departmentData?.result && (
          <Element name={departmentData?.result?.title}>
            <FixBox
              bg={slang !== "department-science" ? ListColor2[slang] : ""}
            >
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  <FadeInSection axis="x">
                    <CustomCarousel autoplay bg={ListColor1[slang]}>
                      {departmentData?.result?.image &&
                        departmentData?.result?.image[0]?.image_0 && (
                          <img
                            loading="lazy"
                            src={departmentData?.result?.image[0]?.image_0}
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                            }}
                          />
                        )}
                      {departmentData?.result?.image &&
                        departmentData?.result?.image[0]?.image_1 && (
                          <img
                            loading="lazy"
                            src={departmentData?.result?.image[0]?.image_1}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                      {departmentData?.result?.image &&
                        departmentData?.result?.image[0]?.image_2 && (
                          <img
                            loading="lazy"
                            src={departmentData?.result?.image[0]?.image_2}
                            alt="icon group"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        )}
                    </CustomCarousel>
                  </FadeInSection>
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.result?.title}</SubTitle>

                  {slang !== "department-agricultural" &&
                  slang !== "department-public-health" &&
                  slang !== "department-science" ? (
                    <>
                      <SubDetail className="bg-circle" bottom="0">
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_0}
                      </SubDetail>

                      {(departmentData?.result?.text[0]?.text_1 ||
                        departmentData?.result?.text[0]?.text_2) && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_1 &&
                            departmentData?.result?.text[0]?.text_1}
                          {departmentData?.result?.text[0]?.text_2 &&
                            departmentData?.result?.text[0]?.text_2}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_3 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_3}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_4 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_4}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_5 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_6 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_6}
                        </SubDetail>
                      )}

                      <SubDetail className="bg-circle">
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_7}
                      </SubDetail>
                    </>
                  ) : slang === "department-public-health" ? (
                    <>
                      <SubHead>
                        {departmentData?.result?.text[0]?.text_0}
                      </SubHead>
                      <SubDetail top="0">
                        {departmentData?.result?.text[0]?.text_1}
                      </SubDetail>

                      <SubHead>
                        {departmentData?.result?.text[0]?.text_2}
                      </SubHead>
                      <SubDetail bottom="0" top="0">
                        {departmentData?.result?.text[0]?.text_3}
                      </SubDetail>

                      <SubDetail className="bg-circle" bottom="0">
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_4}
                      </SubDetail>

                      {(departmentData?.result?.text[0]?.text_5 ||
                        departmentData?.result?.text[0]?.text_6) && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5 &&
                            departmentData?.result?.text[0]?.text_5}

                          {departmentData?.result?.text[0]?.text_6 &&
                            departmentData?.result?.text[0]?.text_6}

                          {departmentData?.result?.text[0]?.text_7 &&
                            departmentData?.result?.text[0]?.text_7}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_8 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_8}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_9 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_9}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_10 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_10}
                        </SubDetail>
                      )}
                      {departmentData?.result?.text[0]?.text_11 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_11}
                        </SubDetail>
                      )}

                      <SubDetail className="bg-circle" bottom="0">
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_12}
                      </SubDetail>
                      {departmentData?.result?.text[0]?.text_13 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_13}
                        </SubDetail>
                      )}
                    </>
                  ) : slang === "department-science" ? (
                    <>
                      <TextBold className="bg-circle" bottom="0" indent="32">
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        <div style={{ display: "block" }}>
                          เกรดเฉลี่ยเกรดเฉลี่ยสะสม 3.50 ขึ้นไป ไม่มี U และ F
                          ไม่เรียนซ้ำเพื่อปรับเกรด D D+
                          <span> จะได้รับ</span>
                        </div>
                      </TextBold>

                      {departmentData?.result?.text[0]?.text_1 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_1 &&
                            departmentData?.result?.text[0]?.text_1}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_2 && (
                        <TextBold indent="32" bottom="0">
                          <div style={{ display: "block" }}>
                            หากได้รับปริญญาเกียรตินิยมอันดับหนึ่ง
                            พร้อมทั้งมีแต้มเฉลี่ยสูงสุดในสาขา
                            <span> จะได้รับ</span>
                          </div>
                        </TextBold>
                      )}

                      {departmentData?.result?.text[0]?.text_3 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_3}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_4 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_4}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_5 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_6 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_6}
                        </SubDetail>
                      )}

                      <TextBold indent="32" bottom="0" className="bg-circle">
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        <div style={{ display: "block" }}>
                          เกรดเฉลี่ยสะสม 3.25 ขึ้นไป ไม่มี U และ F
                          ไม่เรียนซ้ำเพื่อปรับเกรด D D+
                          <span> จะได้รับ</span>
                        </div>
                      </TextBold>

                      {departmentData?.result?.text[0]?.text_8 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_8}
                        </SubDetail>
                      )}
                    </>
                  ) : (
                    <>
                      <SubHead>
                        {departmentData?.result?.text[0]?.text_0}
                      </SubHead>
                      <SubDetail top="0">
                        {departmentData?.result?.text[0]?.text_1}
                      </SubDetail>

                      <SubHead>
                        {departmentData?.result?.text[0]?.text_2}
                      </SubHead>
                      <SubDetail bottom="0" top="0">
                        {departmentData?.result?.text[0]?.text_3}
                      </SubDetail>

                      <SubDetail className="bg-circle" bottom="0">
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_4}
                      </SubDetail>

                      {(departmentData?.result?.text[0]?.text_5 ||
                        departmentData?.result?.text[0]?.text_6) && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5 &&
                            departmentData?.result?.text[0]?.text_5}
                          {departmentData?.result?.text[0]?.text_6 &&
                            departmentData?.result?.text[0]?.text_6}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_7 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_7}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_8 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_8}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_9 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_9}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_10 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_10}
                        </SubDetail>
                      )}

                      <SubDetail className="bg-circle">
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_11}
                      </SubDetail>
                    </>
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.sucess && (
          <Element name={departmentData?.sucess?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.sucess?.title}</SubTitle>
                {departmentData?.sucess?.text &&
                  departmentData?.sucess?.text.map((item) => {
                    return (
                      <>
                        <SubDetail indent="32">
                          {item?.text_0 && item?.text_0} <br />
                        </SubDetail>

                        {item?.text_1 && <SubHead>{item?.text_1}</SubHead>}
                        {(item?.text_2 || item?.text_3 || item?.text_4) && (
                          <SubDetail top="0">
                            {item?.text_2 && item?.text_2} <br />
                            {item?.text_3 && item?.text_3} <br />
                            {item?.text_4 && item?.text_4}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
              </Col>

              <Col span={12} offset={1}>
                {departmentData?.sucess?.image ? (
                  departmentData?.sucess?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })
                ) : (
                  <img
                    loading="lazy"
                    src={engineer1}
                    alt="icon group"
                    style={{ borderRadius: "20px", width: "100%" }}
                  />
                )}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-engineering" && departmentData?.teacher && (
          <Element name={departmentData?.teacher?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.teacher?.image ? (
                    departmentData?.teacher?.image.map((item) => {
                      return (
                        <FadeInSection axis="y">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                  {departmentData?.teacher?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_0}
                          </SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_2}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail top="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}

                        {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                        {item?.text_5 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {spliteLink(
                              item?.text_5,
                              "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ "
                            )}
                          </SubDetail>
                        )}
                        {item?.text_6 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {spliteLink(
                              item?.text_6,
                              "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่"
                            )}
                          </SubDetail>
                        )}
                        {item?.text_7 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_7}
                          </SubDetail>
                        )}
                        {item?.text_8 && (
                          <SubDetail top="0" indent="32">
                            {spliteLinkEng(item?.text_8, "ดูต่อ ")}
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {departmentData?.estimate &&
          (slang !== "department-engineering" &&
          slang !== "department-social" ? (
            <Element name={departmentData?.estimate?.title}>
              <FixBox
                bg={slang === "department-science" ? ListColor2[slang] : ""}
              >
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.estimate?.title}</SubTitle>
                    <SubDetail
                      bottom={slang !== "department-agricultural" ? "32" : "0"}
                      indent={slang === "department-agricultural" ? "32" : "0"}
                    >
                      {departmentData?.estimate?.text[0].text_0}
                    </SubDetail>

                    {slang !== "department-agricultural"
                      ? departmentData?.estimate?.text[0].text_1 && (
                          <SubHead>
                            {departmentData?.estimate?.text[0].text_1}
                          </SubHead>
                        )
                      : departmentData?.estimate?.text[0].text_1 && (
                          <SubDetail bottom="0" top="0" indent="32">
                            {departmentData?.estimate?.text[0].text_1}
                          </SubDetail>
                        )}

                    {departmentData?.estimate?.text[0].text_2 && (
                      <SubDetail
                        bottom={
                          slang !== "department-agricultural" ? "0" : "32"
                        }
                        top="0"
                        indent="32"
                      >
                        {slang === "department-science"
                          ? spliteLink(
                              departmentData?.estimate?.text[0].text_2,
                              "1) Log in : "
                            )
                          : departmentData?.estimate?.text[0].text_2}
                      </SubDetail>
                    )}

                    {slang !== "department-agricultural"
                      ? departmentData?.estimate?.text[0].text_3 && (
                          <SubDetail bottom="0" top="0" indent="32">
                            {departmentData?.estimate?.text[0].text_3}
                          </SubDetail>
                        )
                      : departmentData?.estimate?.text[0].text_3 && (
                          <SubHead>
                            {departmentData?.estimate?.text[0].text_3}
                          </SubHead>
                        )}

                    {departmentData?.estimate?.text[0].text_4 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {slang === "department-agricultural"
                          ? spliteLink(
                              departmentData?.estimate?.text[0].text_4,
                              "1 Log in: "
                            )
                          : departmentData?.estimate?.text[0].text_4}
                      </SubDetail>
                    )}

                    {departmentData?.estimate?.text[0].text_5 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_5}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_6 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_6}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_7 && (
                      <SubDetail top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_7}
                      </SubDetail>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {slang !== "department-agricultural" ? (
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.estimate?.image &&
                            departmentData?.estimate?.image[0]?.image_0
                              ? departmentData?.estimate?.image[0]?.image_0
                              : engineer1
                          }
                          alt="icon rectangle"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      </FadeInSection>
                    ) : (
                      departmentData?.estimate?.image &&
                      departmentData.estimate.image.map((item) => {
                        return (
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })
                    )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          ) : (
            slang !== "department-social" && (
              <Element name={departmentData?.estimate?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.estimate?.title}</SubTitle>
                    <SubDetail
                      bottom={slang !== "department-agricultural" ? "32" : "0"}
                    >
                      {departmentData?.estimate?.text[0].text_0}
                    </SubDetail>

                    {slang !== "department-agricultural"
                      ? departmentData?.estimate?.text[0].text_1 && (
                          <SubHead>
                            {departmentData?.estimate?.text[0].text_1}
                          </SubHead>
                        )
                      : departmentData?.estimate?.text[0].text_1 && (
                          <SubDetail bottom="0" top="0">
                            {departmentData?.estimate?.text[0].text_1}
                          </SubDetail>
                        )}

                    {departmentData?.estimate?.text[0].text_2 && (
                      <SubDetail
                        bottom={
                          slang !== "department-agricultural" ? "0" : "32"
                        }
                        top="0"
                        indent="32"
                      >
                        {spliteLink(
                          departmentData?.estimate?.text[0].text_2,
                          "1) Log in : "
                        )}
                      </SubDetail>
                    )}

                    {slang !== "department-agricultural"
                      ? departmentData?.estimate?.text[0].text_3 && (
                          <SubDetail bottom="0" top="0" indent="32">
                            {departmentData?.estimate?.text[0].text_3}
                          </SubDetail>
                        )
                      : departmentData?.estimate?.text[0].text_3 && (
                          <SubHead>
                            {departmentData?.estimate?.text[0].text_3}
                          </SubHead>
                        )}

                    {departmentData?.estimate?.text[0].text_4 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_4}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_5 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_5}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_6 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_6}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_7 && (
                      <SubDetail top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_7}
                      </SubDetail>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.estimate?.image &&
                          departmentData?.estimate?.image[0]?.image_0
                            ? departmentData?.estimate?.image[0]?.image_0
                            : engineer1
                        }
                        alt="icon rectangle"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    </FadeInSection>
                  </Col>
                </Row>
              </Element>
            )
          ))}

        {slang !== "department-dentistry" &&
          slang !== "department-degitech" &&
          slang !== "department-public-health" &&
          slang !== "department-science" &&
          slang !== "department-medicine" &&
          departmentData?.activity && (
            <Element name={departmentData?.activity?.title}>
              <FixBox bg={ListColor2[slang]}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    {departmentData?.activity?.image ? (
                      departmentData?.activity?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_3 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_3}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                  <Col span={12} offset={1}>
                    <SubTitle>{departmentData?.activity?.title}</SubTitle>
                    {departmentData?.activity?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0">{item?.text_0}</SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              indent={
                                slang === "department-engineering" ? "32" : "0"
                              }
                            >
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              indent={
                                slang === "department-engineering" ? "32" : "0"
                              }
                            >
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail
                              top="0"
                              bottom={
                                slang === "department-engineering" ||
                                slang === "department-public-health"
                                  ? "0"
                                  : "32"
                              }
                              indent={
                                slang === "department-engineering" ? "32" : "0"
                              }
                            >
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {slang !== "department-engineering" ? (
                            slang === "department-public-health" ? (
                              <SubDetail top="0" bottom="0">
                                {item?.text_4}
                              </SubDetail>
                            ) : (
                              item?.text_4 && <SubHead>{item?.text_4}</SubHead>
                            )
                          ) : (
                            item?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_4}
                              </SubDetail>
                            )
                          )}
                          {item?.text_5 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              indent={
                                slang === "department-engineering" ? "32" : "0"
                              }
                            >
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail
                              top="0"
                              bottom="0"
                              indent={
                                slang === "department-engineering" ? "32" : "0"
                              }
                            >
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_7}
                            </SubDetail>
                          )}
                          {item?.text_8 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_8}
                            </SubDetail>
                          )}
                          {item?.text_9 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_9}
                            </SubDetail>
                          )}
                          {item?.text_10 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_10}
                            </SubDetail>
                          )}
                          {item?.text_11 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_11}
                            </SubDetail>
                          )}
                          {item?.text_12 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_12}
                            </SubDetail>
                          )}
                          {item?.text_13 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_13}
                            </SubDetail>
                          )}
                          {item?.text_14 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_14}
                            </SubDetail>
                          )}
                          {item?.text_15 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_15}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {departmentData?.evaluating && (
          <Element name={departmentData?.evaluating?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.evaluating?.title}</SubTitle>
                {departmentData?.evaluating?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail bottom="0" indent="32">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_2}
                        </SubDetail>
                      )}

                      {item?.text_3 && <SubHead>{item?.text_3}</SubHead>}
                      {item?.text_4 && (
                        <SubDetail bottom="0" indent="32">
                          {spliteLink(item?.text_4, "1 Log in: ")}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" bottom="0" indent="32">
                          {item?.text_6}
                        </SubDetail>
                      )}
                      {item?.text_7 && (
                        <SubDetail top="0" indent="32">
                          {item?.text_7}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
              <Col span={12} offset={1}>
                {departmentData?.evaluating?.image &&
                  departmentData?.evaluating?.image.map((item) => {
                    return (
                      <FadeInSection axis="y">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {departmentData?.project &&
          (slang !== "department-engineering" &&
          slang !== "department-science" &&
          slang !== "department-dentistry" ? (
            <Element name={departmentData?.project?.title}>
              <FixBox bg={ListColor2[slang]}>
                <Row gutter={24} className="row-group">
                  <Col
                    span={11}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {departmentData?.project?.image &&
                      departmentData?.project?.image.map((item) => {
                        return (
                          // <FadeInSection axis='y'>
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })}
                  </Col>
                  <Col span={12} offset={1}>
                    <SubTitle>{departmentData?.project?.title}</SubTitle>
                    <SubDetail>
                      {departmentData?.project?.text[0]?.text_0}
                    </SubDetail>
                    <SubHead>
                      <a
                        href="https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <img
                          src={downloadIcon}
                          alt="icon download file"
                          loading="lazy"
                        />
                        ดาวน์โหลดแบบฟอร์ม
                      </a>
                    </SubHead>
                    {departmentData?.project?.text[0]?.text_1 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_2 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_2}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_3 && (
                      <TextNote>
                        {departmentData?.project?.text[0]?.text_3}
                      </TextNote>
                    )}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          ) : (
            slang !== "department-dentistry" && (
              <Element name={departmentData?.project?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.project?.title}</SubTitle>
                    <SubDetail>
                      {departmentData?.project?.text[0]?.text_0}
                    </SubDetail>
                    <SubHead>
                      <a
                        href="https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <img
                          src={downloadIcon}
                          alt="icon download file"
                          loading="lazy"
                        />
                        ดาวน์โหลดแบบฟอร์ม
                      </a>
                    </SubHead>
                    {departmentData?.project?.text[0]?.text_1 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_2 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_2}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_3 && (
                      <TextNote>
                        {departmentData?.project?.text[0]?.text_3}
                      </TextNote>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {departmentData.project?.image &&
                    departmentData.project.image[0]?.image_0 &&
                    !departmentData.project.image[0]?.image_1 ? (
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={departmentData.project.image[0]?.image_0}
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        />
                      </FadeInSection>
                    ) : (
                      departmentData.project.image.map((item) => {
                        return (
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item.image_0 && (
                              <img
                                loading="lazy"
                                src={item.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_1 && (
                              <img
                                loading="lazy"
                                src={item.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_2 && (
                              <img
                                loading="lazy"
                                src={item.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })
                    )}
                  </Col>
                </Row>
              </Element>
            )
          ))}

        {departmentData?.project_show && (
          <Element name={departmentData?.project_show?.title}>
            <FixBox bg={ListColor2[slang]}>
              <Row gutter={24} className="row-group">
                <Col span={11}>
                  {departmentData?.project_show?.image ? (
                    departmentData?.project_show?.image.map((item) => {
                      return (
                        <FadeInSection axis="x">
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item?.image_0 && (
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_1 && (
                              <img
                                loading="lazy"
                                src={item?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                            {item?.image_2 && (
                              <img
                                loading="lazy"
                                src={item?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          </CustomCarousel>
                        </FadeInSection>
                      );
                    })
                  ) : (
                    <img
                      loading="lazy"
                      src={engineer1}
                      alt="icon group"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  )}
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.project_show?.title}</SubTitle>
                  {departmentData?.project_show?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubDetail indent="32">{item?.text_0}</SubDetail>
                        )}
                        {item?.text_1 && (
                          <SubDetail top="0" bottom="0" indent="32">
                            {item?.text_1}
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail top="0" bottom="0">
                            {spliteLinkProject(
                              item?.text_2,
                              "Download ",
                              "https://web.sut.ac.th/dbg/dbg_form.html"
                            )}
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail bottom="0" indent="32">
                            {item?.text_3}
                          </SubDetail>
                        )}
                        {item?.text_4 && (
                          <TextNote top="0">{item?.text_4}</TextNote>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-engineering" && departmentData?.q1 && (
          <Element name={departmentData?.q1?.title}>
            <SubTitle top="50" bottom="0" align="center">
              {departmentData?.q1?.title}
            </SubTitle>

            <NameCourse align="center" top="0" bottom="35">
              {departmentData?.q1?.text[0]?.text_0}
            </NameCourse>

            {departmentData?.q1?.text && departmentData?.q1?.text[0] && (
              <>
                <Row className="row-col-3">
                  <Col span={8}>
                    <Box>
                      <NumberList>
                        <NumberImage number={1} position={0} />
                      </NumberList>
                      <NameCourse bottom="4">
                        กรอกแบบฟอร์มขอสละสิทธิ์
                      </NameCourse>

                      <a
                        href={
                          "https://beta.sut.ac.th/ie/%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b5-2"
                        }
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <img
                          loading="lazy"
                          src={downloadIcon}
                          alt="icon download file"
                          style={{ height: "32px", marginRight: "12px" }}
                        />
                        <span>ดาวน์โหลดแบบฟอร์ม</span>
                      </a>
                    </Box>
                  </Col>
                  <Col span={8}>
                    <Box>
                      <NumberList>
                        <NumberImage number={2} position={45} />
                      </NumberList>
                      <NameCourse bottom="4">
                        นําแบบฟอร์ม เข้าพบและขออนุมัติ ตามลําดับ
                      </NameCourse>
                      <SubDetail left="5" top="0" bottom="0">
                        {"อาจารย์ที่ปรึกษา >"}
                      </SubDetail>
                      <SubDetail left="5" top="0" bottom="0">
                        {" หัวหน้าสาขา >"}
                      </SubDetail>
                      <SubDetail left="5" top="0">
                        นำแบบฟอร์มส่งที่สำนักวิชาวิศวกรรมศาสตร์
                      </SubDetail>
                    </Box>
                  </Col>

                  <Col span={8}>
                    <Box>
                      <NumberList>
                        <NumberImage number={3} position={90} />
                      </NumberList>
                      <NameCourse bottom="4">
                        ตรวจสอบรายชื่อได้ 2 ทาง
                      </NameCourse>

                      <div className="link-web eng">
                        <a
                          href={`https://beta.sut.ac.th/ie/%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b5-2`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          1) <u> เว็บไซต์ศูนย์บริการการศึกษา CES</u>
                        </a>
                      </div>
                      <div className="link-web eng">
                        <a
                          href={`https://eng.sut.ac.th/`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          2) <u> เว็บไซต์สำนักวิชาวิศวกรรมศาสตร์</u>
                        </a>
                      </div>
                    </Box>
                  </Col>
                </Row>

                <ListImage
                  noteText="Note: สามารถสละสิทธิ์ได้ในเทอม 3 ก่อนเลือกสาขา ประมาณ 1 สัปดาห์์เท่านั้น ถ้าได้รับอนุมัติให้สละสิทธิ์แล้ว จะเลือกสาขาวิชาฯ ใหม่ได้ตามปกติ"
                  type="note"
                  font="Noto Sans Thai"
                />
              </>
            )}
          </Element>
        )}

        {slang === "department-engineering" && departmentData?.table_grad && (
          <Element name={departmentData?.table_grad?.title}>
            <FixBox bg={ListColor2[slang]}>
              <SubTitle top="50" align="center">
                {departmentData?.table_grad?.title}
              </SubTitle>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TableGPAX col={4} data4={gradeData} />
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Line />
              </div>
              <Detail color="#81000F">
                <a
                  href="http://bulletin.sut.ac.th/enrollment/calculate-grade"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    loading="lazy"
                    src={handRightIcon}
                    alt="icon download file"
                    style={{ margin: "0 20px", height: "32px" }}
                  />
                  <span style={{ fontWeight: "600" }}>
                    ดูตัวอย่างการคำนวณ grade point
                  </span>
                </a>
              </Detail>

              <ListImage
                noteText="Warning: 1) หากอยากได้สาขาที่ถูกใจ ต้องทํา Grade Point ให้สูงเข้าไว้ 2) อาจมีการสลับเทอมของกลุ่มการลงทะเบียน ตามกลุ่มนักศึกษา"
                type="note"
                font="Noto Sans Thai"
              />
            </FixBox>
          </Element>
        )}

        {departmentData?.select_subject && (
          <Element name={departmentData?.select_subject?.title}>
            <SubTitle>{departmentData?.select_subject?.title}</SubTitle>
            <Row gutter={[24, 24]} className="row-system">
              <Col span={12}>
                <FadeInSection axis="y">
                  <img
                    loading="lazy"
                    src={
                      departmentData?.select_subject?.image &&
                      departmentData?.select_subject?.image[0]?.image_0
                    }
                    alt="register credits"
                    style={styleImage}
                  />
                </FadeInSection>
                {departmentData?.select_subject?.text && (
                  <>
                    <TextHead>
                      1) {departmentData?.select_subject?.text[0]?.text_0}
                    </TextHead>
                    <Detail align="left" bottom="0">
                      {departmentData?.select_subject?.text[0]?.text_1}
                    </Detail>
                    <Detail align="left" top="0">
                      {departmentData?.select_subject?.text[0]?.text_2}
                    </Detail>
                  </>
                )}
              </Col>
              <Col span={12}>
                <FadeInSection axis="y">
                  <img
                    loading="lazy"
                    src={
                      departmentData?.select_subject?.image &&
                      departmentData?.select_subject?.image[0]?.image_1
                    }
                    alt="register credits"
                    style={styleImage}
                  />
                </FadeInSection>
                {departmentData?.select_subject?.text && (
                  <>
                    <TextHead>
                      2) {departmentData?.select_subject?.text[0]?.text_3}
                    </TextHead>
                    <Detail align="left">
                      {departmentData?.select_subject?.text[0]?.text_4}
                    </Detail>
                  </>
                )}
              </Col>
            </Row>

            {departmentData?.select_subject?.text && (
              <>
                <TttleSelect>
                  {departmentData?.select_subject?.text[0]?.text_5}
                </TttleSelect>

                <Detail>
                  {departmentData?.select_subject?.text[0]?.text_6}
                </Detail>
                <div style={{ width: "90%" }}>
                  <Line />
                </div>
                <TttleSelect>
                  {departmentData?.select_subject?.text[0]?.text_7}
                </TttleSelect>
                <Detail>
                  {departmentData?.select_subject?.text[0]?.text_8}
                </Detail>
              </>
            )}

            <Detail>
              <a
                href="http://web.sut.ac.th/ces/2018/ces/formST/05.pdf"
                target="_blank"
                rel="noreferrer"
                download
              >
                <img
                  loading="lazy"
                  src={downloadIcon}
                  alt="icon download file"
                  style={{ margin: "0 20px", height: "32px" }}
                />
                <span>ดาวน์โหลดแบบฟอร์ม</span>
              </a>
            </Detail>

            {departmentData?.select_subject?.text && (
              <ListImage
                noteText={departmentData?.select_subject?.text[0]?.text_10}
                type="note"
                font="Noto Sans Thai"
              />
            )}
          </Element>
        )}

        {slang === "department-engineering" &&
          departmentData?.registered_GPAX && (
            <Element name={departmentData?.registered_GPAX?.title}>
              <FixBox bg="#FBFBFB">
                <Row gutter={[24, 24]} className="row-contact">
                  <Col span={8}>
                    <FadeInSection axis="x">
                      <img
                        loading="lazy"
                        src={engGPAX}
                        alt="registered GPAX"
                        style={styleImage}
                      />
                    </FadeInSection>
                  </Col>
                  <Col span={15} offset={1} className="col-leave">
                    <SubTitle>
                      {departmentData?.registered_GPAX?.title}
                    </SubTitle>
                    {departmentData?.registered_GPAX?.text &&
                      departmentData?.registered_GPAX?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <NumberList>
                                <NumberImage number={1} position={0} />
                                <div>
                                  Download ใบยืนยันการพบอาจารย์ที่ปรึกษา ได้ 2
                                  ช่องทาง
                                  <div className="link-web eng">
                                    <a
                                      href={
                                        "https://reg3.sut.ac.th/registrar/Form/FormAdvisors.asp"
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      1){" "}
                                      <u>
                                        เว็บไซต์ Download
                                        ใบยืนยันการพบอาจารย์ที่ปรึกษา
                                      </u>
                                    </a>
                                  </div>
                                  <div className="link-web eng">
                                    <a
                                      href={
                                        "http://sutgateway.sut.ac.th/ces/%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2/download-%E0%B8%84%E0%B8%B3%E0%B8%A3%E0%B8%AD%E0%B8%87/"
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      2){" "}
                                      <u>
                                        แบบฟอร์มคำร้องสำหรับ นศ.ที่ GPAX ต่ำกว่า
                                        2.00 โดยศูนย์บริการการศึกษา CES
                                      </u>
                                    </a>
                                  </div>
                                </div>
                              </NumberList>
                            )}
                            {item?.text_1 && (
                              <NumberList>
                                <NumberImage number={2} position={45} />
                                กรอกข้อมูล
                              </NumberList>
                            )}

                            {item?.text_2 && (
                              <NumberList>
                                <NumberImage number={3} position={90} />
                                ส่งเอกสารตามที่ระบบกำหนด
                              </NumberList>
                            )}
                            {item?.text_3 && (
                              <NumberList>
                                <NumberImage number={4} position={180} />
                                พบอาจารย์ที่ปรึกษาแบบออนไลน์
                                หรือตามที่อาจารย์ที่ปรึกษากำหนด
                              </NumberList>
                            )}

                            {item?.text_4 && (
                              <ListImage
                                noteText="Note: หากมีปัญหาเรื่องดาวน์โหลดแบบฟอร์มไม่ได้ ติดต่อฝ่ายวิเคราะห์และพัฒนาระบบ โทร. 0-4422-4223"
                                type="note"
                                font="Noto Sans Thai"
                              />
                            )}
                          </>
                        );
                      })}
                  </Col>
                </Row>
              </FixBox>
            </Element>
          )}

        {departmentData?.final && (
          <Element name={departmentData?.final?.title}>
            <FixBox
              bg={slang === "department-science" ? ListColor2[slang] : ""}
            >
              <Row gutter={24} className="row-group">
                <Col
                  span={11}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FadeInSection axis="y">
                    <img
                      loading="lazy"
                      src={
                        departmentData?.final?.image
                          ? departmentData?.final?.image[0]?.image_0
                          : maindataSci
                      }
                      alt="icon rectangle"
                      style={{ borderRadius: "20px", width: "100%" }}
                    />
                  </FadeInSection>
                </Col>
                <Col span={12} offset={1}>
                  <SubTitle>{departmentData?.final?.title}</SubTitle>
                  <SubDetail indent="32">
                    {departmentData?.final?.text[0]?.text_0}
                  </SubDetail>
                  {departmentData?.final?.text[0]?.text_1 && (
                    <SubDetail bottom="0" indent="32">
                      {departmentData?.final?.text[0]?.text_1}
                    </SubDetail>
                  )}
                  {departmentData?.final?.text[0]?.text_2 && (
                    <SubDetail bottom="0" top="0" indent="32">
                      {departmentData?.final?.text[0]?.text_2}
                    </SubDetail>
                  )}
                  {departmentData?.final?.text[0]?.text_3 && (
                    <SubDetail bottom="0" top="0" indent="32">
                      {departmentData?.final?.text[0]?.text_3}
                    </SubDetail>
                  )}
                  {departmentData?.final?.text[0]?.text_4 && (
                    <SubDetail bottom="0" top="0" indent="32">
                      {departmentData?.final?.text[0]?.text_4}
                    </SubDetail>
                  )}
                  {departmentData?.final?.text[0]?.text_5 && (
                    <SubDetail top="0" indent="32">
                      {departmentData?.final?.text[0]?.text_5}
                    </SubDetail>
                  )}
                  {departmentData?.final?.text[0]?.text_6 && (
                    <TextNote>
                      {departmentData?.final?.text[0]?.text_6}
                    </TextNote>
                  )}
                </Col>
              </Row>
            </FixBox>
          </Element>
        )}

        {slang === "department-science" && departmentData?.activity && (
          <Element name={departmentData?.activity?.title}>
            <Row gutter={24} className="row-group">
              <Col span={11}>
                <SubTitle>{departmentData?.activity?.title}</SubTitle>
                {departmentData?.activity?.text.map((item) => {
                  return (
                    <>
                      {item?.text_0 && (
                        <SubDetail bottom="0" indent="35">
                          {item?.text_0}
                        </SubDetail>
                      )}
                      {item?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_1}
                        </SubDetail>
                      )}
                      {item?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_2}
                        </SubDetail>
                      )}
                      {item?.text_3 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_3}
                        </SubDetail>
                      )}
                      {item?.text_4 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_4}
                        </SubDetail>
                      )}
                      {item?.text_5 && (
                        <SubDetail top="0" bottom="0" indent="35">
                          {item?.text_5}
                        </SubDetail>
                      )}
                      {item?.text_6 && (
                        <SubDetail top="0" indent="35">
                          {item?.text_6}
                        </SubDetail>
                      )}
                    </>
                  );
                })}
              </Col>
              <Col span={12} offset={1}>
                {departmentData?.activity?.image &&
                  departmentData?.activity?.image.map((item) => {
                    return (
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {item?.image_0 && (
                            <img
                              loading="lazy"
                              src={item?.image_0}
                              alt="icon group"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                              }}
                            />
                          )}
                          {item?.image_1 && (
                            <img
                              loading="lazy"
                              src={item?.image_1}
                              alt="icon group"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                              }}
                            />
                          )}
                          {item?.image_2 && (
                            <img
                              loading="lazy"
                              src={item?.image_2}
                              alt="icon group"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                              }}
                            />
                          )}
                          {item?.image_3 && (
                            <img
                              loading="lazy"
                              src={item?.image_3}
                              alt="icon group"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                              }}
                            />
                          )}
                        </CustomCarousel>
                      </FadeInSection>
                    );
                  })}
              </Col>
            </Row>
          </Element>
        )}

        {slang === "department-science" &&
          departmentData?.register &&
          departmentData?.grade &&
          departmentData?.news &&
          departmentData?.news_1 && (
            <Element name={departmentData.register?.title}>
              <Element name={departmentData.grade?.title}>
                <Element name={departmentData.news?.title}>
                  <Element name={departmentData.news_1?.title}>
                    <FixBox bg={ListColor2[slang]}>
                      <Row gutter={24} className="row-group">
                        <Col span={11}>
                          <SubTitle bottom="0">
                            {departmentData?.register?.title}
                          </SubTitle>
                          <SubDetail top="0">
                            และขั้นตอนต่าง ๆ ที่จำเป็นต้องรู้
                          </SubDetail>
                          {renderBtn(
                            "http://bulletin.sut.ac.th/enrollment",
                            "อ่านต่อ"
                          )}
                        </Col>
                        <Col span={12} offset={1}>
                          <SubTitle bottom="0">
                            {departmentData?.grade?.title}
                          </SubTitle>
                          <SubDetail top="0">และตัวอย่าง</SubDetail>
                          {renderBtn(
                            "http://bulletin.sut.ac.th/enrollment/calculate-grade",
                            "อ่านต่อ"
                          )}
                        </Col>
                      </Row>
                      <Row gutter={24} className="row-group">
                        <Col span={11}>
                          <SubTitle bottom="0">
                            {departmentData?.news?.title}
                          </SubTitle>
                          <SubDetail top="0">
                            ช่องทางติดตามข่าวสารและกิจกรรมต่าง ๆ
                            จากคณะประสานงานวิทยาศาสตร์ มทส.
                          </SubDetail>
                          {renderBtn(
                            "https://web.facebook.com/sciencesutstudents",
                            "ติดตามเฟซบุ๊ก"
                          )}
                        </Col>
                        <Col span={12} offset={1}>
                          <SubTitle bottom="0">
                            {departmentData?.news_1?.title}
                          </SubTitle>
                          <SubDetail top="0">
                            ช่องทางติดตามข่าวประชาสัมพันธ์/กิจกรรม/ทุน
                            จากสำนักวิชาวิทยาศาสตร์
                          </SubDetail>
                          {renderBtn(
                            "https://science-sut.notion.site/a1cf60801656475dbd280aa657b568dc?pvs=4",
                            "อ่านต่อ"
                          )}
                        </Col>
                      </Row>
                    </FixBox>
                  </Element>
                </Element>
              </Element>
            </Element>
          )}

        {contactData && (
          <>
            <SubTitle top="60" align="center">
              {ListContact[slang]}
            </SubTitle>
            <Row
              gutter={24}
              style={{ marginTop: "50px" }}
              className="row-contact"
            >
              <Col span={8}>
                <CardContact background={ListColorContact[slang]}>
                  <div className="container">
                    <DetailContact
                      color={`${
                        slang === "department-science"
                          ? "var(--black)"
                          : "white"
                      }`}
                      title={contactData[0]?.title}
                      phone={contactData[0]?.phone_1}
                      office={contactData[0]?.phone_2}
                      facebook={contactData[0]?.fb}
                      website={contactData[0]?.site}
                      email1={contactData[0]?.email_1}
                      email2={contactData[0]?.email_2}
                      email3={contactData[0]?.email_3}
                      line={contactData[0]?.line}
                      indent="40"
                      type="department"
                    />
                  </div>

                  {contactData && (
                    <img
                      loading="lazy"
                      src={
                        contactData[0]?.image
                          ? contactData[0]?.image
                          : listImageContact[slang]
                      }
                      alt="icon rectangle"
                      style={{
                        borderRadius: "20px",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    />
                  )}
                </CardContact>
              </Col>

              <Col span={15} offset={1}>
                <Row gutter={24}>
                  {contactData.length > 1
                    ? contactData.slice(1).map((item, index) => {
                        return (
                          <Col
                            span={12}
                            style={{ padding: "10px" }}
                            key={index}
                          >
                            <div style={styleDetailContact}>
                              <DetailContact
                                color="var(--black)"
                                title={item?.title}
                                phone={item?.phone_1}
                                office={item?.phone_2}
                                facebook={item?.fb}
                                website={item?.site}
                                email1={item?.email_1}
                                email2={item?.email_2}
                                email3={item?.email_3}
                                line={item?.line}
                                indent={
                                  slang === "department-dentistry" ? "0" : "40"
                                }
                                slang={slang}
                                type="branch"
                              />
                            </div>
                          </Col>
                        );
                      })
                    : contactData[0]?.address !== "" && (
                        <Col span={12} style={{ padding: "10px" }}>
                          <DetailContact
                            color="var(--black)"
                            title={contactData[0]?.title}
                            address={contactData[0]?.address}
                            slang={slang}
                            type="branch"
                          />
                        </Col>
                      )}
                </Row>
              </Col>
            </Row>
          </>
        )}

        <FixBoxLayout bg={ListColor2[slang]}>
          <div className="layout-view">
            <Row className="row-group" style={{ alignItems: "center" }}>
              <Col span={8}>
                <img
                  loading="lazy"
                  src={stuView}
                  style={{ width: "100%", maxWidth: "460px" }}
                  alt="student view"
                />
              </Col>
              <Col span={16}>
                <div style={{ maxwWidth: "450px" }}>
                  <SubHead align="center">{ListView[slang]}</SubHead>
                  <View>
                    <CountUp
                      start={0}
                      end={
                        departmentData?.visitor ? departmentData?.visitor : 0
                      }
                      duration={2}
                      useEasing={true}
                      useGrouping={true}
                      separator=","
                      decimals={0}
                      decimal=","
                    />
                  </View>
                  <SubHead align="center">ครั้ง</SubHead>
                </div>
              </Col>
            </Row>
          </div>
        </FixBoxLayout>
      </Container>
      <ScrollUpBtn />
    </>
  );
};

export default CourseInfoView;
